

const directions: any = [
  {
    geocoded_waypoints: [
      {
        geocoder_status: "OK",
        place_id: "ChIJ-RtDaQ4RLxgRtWwMakOUA8o",
        types: ["establishment", "point_of_interest"],
      },
      {
        geocoder_status: "OK",
        place_id: "ChIJk0qxgoQRLxgRJMpXStqNmSM",
        types: ["establishment", "point_of_interest"],
      },
    ],
    routes: [
      {
        bounds: {
          south: -1.31434,
          west: 36.83923,
          north: -1.3037200000000002,
          east: 36.858160000000005,
        },
        copyrights: "Map data ©2024",
        legs: [
          {
            distance: {
              text: "2.6 km",
              value: 2564,
            },
            duration: {
              text: "5 mins",
              value: 292,
            },
            end_address:
              "PJP Park, Enterprise Rd, Industrial Area, Box 61770 - 00200, Nairobi, Kenya",
            end_location: {
              lat: -1.314339,
              lng: 36.8581644,
            },
            start_address: "P. O. Box 57225 Dakar Rd, Nairobi, Kenya",
            start_location: {
              lat: -1.3037171,
              lng: 36.8400717,
            },
            steps: [
              {
                distance: {
                  text: "0.1 km",
                  value: 107,
                },
                duration: {
                  text: "1 min",
                  value: 24,
                },
                end_location: {
                  lat: -1.3041865,
                  lng: 36.83922990000001,
                },
                polyline: {
                  points: "fs}Fmiz_F`AbCZb@",
                },
                start_location: {
                  lat: -1.3037171,
                  lng: 36.8400717,
                },
                travel_mode: "DRIVING",
                encoded_lat_lngs: "fs}Fmiz_F`AbCZb@",
                path: [
                  {
                    lat: -1.3037200000000002,
                    lng: 36.840070000000004,
                  },
                  {
                    lat: -1.3040500000000002,
                    lng: 36.83941,
                  },
                  {
                    lat: -1.3041900000000002,
                    lng: 36.83923,
                  },
                ],
                instructions: "Head <b>southwest</b> on <b>Dakar Rd</b>",
                maneuver: "",
                start_point: {
                  lat: -1.3037171,
                  lng: 36.8400717,
                },
                end_point: {
                  lat: -1.3041865,
                  lng: 36.83922990000001,
                },
              },
              {
                distance: {
                  text: "1.5 km",
                  value: 1489,
                },
                duration: {
                  text: "3 mins",
                  value: 163,
                },
                end_location: {
                  lat: -1.3114489,
                  lng: 36.8500307,
                },
                maneuver: "roundabout-left",
                polyline: {
                  points:
                    "dv}Fedz_F@?@?@?@@pAa@TINEJGBALIFEDEHKT]b@y@n@cAh@y@f@u@|@_BnAmBf@w@R_@NWDMDIFW?A?A?A?A?A?A?A?C@C@A?C@A@ABC@ABA@?@A@?@?@?@?NQFG@CDGLQR[T]R]T[@CPYR]@ANYHOrBeDl@aA|BwD`A{AXi@FG`@s@n@kAFOBIBQn@sCDY@K?G?MA??AA??AA??AA??AAA?AAA?A?A?A?A?A?A?A@A?A?A@A?A@A@A@A@??A@?@??A@?@?@?@AFGJOZcALc@",
                },
                start_location: {
                  lat: -1.3041865,
                  lng: 36.83922990000001,
                },
                travel_mode: "DRIVING",
                encoded_lat_lngs:
                  "dv}Fedz_F@?@?@?@@pAa@TINEJGBALIFEDEHKT]b@y@n@cAh@y@f@u@|@_BnAmBf@w@R_@NWDMDIFW?A?A?A?A?A?A?A?C@C@A?C@A@ABC@ABA@?@A@?@?@?@?NQFG@CDGLQR[T]R]T[@CPYR]@ANYHOrBeDl@aA|BwD`A{AXi@FG`@s@n@kAFOBIBQn@sCDY@K?G?MA??AA??AA??AA??AAA?AAA?A?A?A?A?A?A?A@A?A?A@A?A@A@A@A@??A@?@??A@?@?@?@AFGJOZcALc@",
                path: [
                  {
                    lat: -1.3041900000000002,
                    lng: 36.83923,
                  },
                  {
                    lat: -1.3042,
                    lng: 36.83923,
                  },
                  {
                    lat: -1.30421,
                    lng: 36.83923,
                  },
                  {
                    lat: -1.3042200000000002,
                    lng: 36.83923,
                  },
                  {
                    lat: -1.30423,
                    lng: 36.839220000000005,
                  },
                  {
                    lat: -1.30464,
                    lng: 36.83939,
                  },
                  {
                    lat: -1.30475,
                    lng: 36.83944,
                  },
                  {
                    lat: -1.3048300000000002,
                    lng: 36.839470000000006,
                  },
                  {
                    lat: -1.30489,
                    lng: 36.839510000000004,
                  },
                  {
                    lat: -1.30491,
                    lng: 36.83952,
                  },
                  {
                    lat: -1.30498,
                    lng: 36.83957,
                  },
                  {
                    lat: -1.30502,
                    lng: 36.839600000000004,
                  },
                  {
                    lat: -1.30505,
                    lng: 36.83963,
                  },
                  {
                    lat: -1.3051000000000001,
                    lng: 36.839690000000004,
                  },
                  {
                    lat: -1.3052100000000002,
                    lng: 36.83984,
                  },
                  {
                    lat: -1.30539,
                    lng: 36.84013,
                  },
                  {
                    lat: -1.30563,
                    lng: 36.84047,
                  },
                  {
                    lat: -1.3058400000000001,
                    lng: 36.84076,
                  },
                  {
                    lat: -1.30604,
                    lng: 36.84103,
                  },
                  {
                    lat: -1.3063500000000001,
                    lng: 36.84151,
                  },
                  {
                    lat: -1.30675,
                    lng: 36.842060000000004,
                  },
                  {
                    lat: -1.30695,
                    lng: 36.84234,
                  },
                  {
                    lat: -1.30705,
                    lng: 36.8425,
                  },
                  {
                    lat: -1.3071300000000001,
                    lng: 36.842620000000004,
                  },
                  {
                    lat: -1.30716,
                    lng: 36.842690000000005,
                  },
                  {
                    lat: -1.30719,
                    lng: 36.842740000000006,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.84286,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.842870000000005,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.84288,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.842890000000004,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.8429,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.84291,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.84292000000001,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.84293,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.84295,
                  },
                  {
                    lat: -1.3072400000000002,
                    lng: 36.84297,
                  },
                  {
                    lat: -1.30725,
                    lng: 36.842980000000004,
                  },
                  {
                    lat: -1.30725,
                    lng: 36.843,
                  },
                  {
                    lat: -1.30726,
                    lng: 36.84301,
                  },
                  {
                    lat: -1.3072700000000002,
                    lng: 36.84302,
                  },
                  {
                    lat: -1.30729,
                    lng: 36.84304,
                  },
                  {
                    lat: -1.3073000000000001,
                    lng: 36.843050000000005,
                  },
                  {
                    lat: -1.30732,
                    lng: 36.84306,
                  },
                  {
                    lat: -1.30733,
                    lng: 36.84306,
                  },
                  {
                    lat: -1.3073400000000002,
                    lng: 36.843070000000004,
                  },
                  {
                    lat: -1.30735,
                    lng: 36.843070000000004,
                  },
                  {
                    lat: -1.30736,
                    lng: 36.843070000000004,
                  },
                  {
                    lat: -1.3073700000000001,
                    lng: 36.843070000000004,
                  },
                  {
                    lat: -1.3073800000000002,
                    lng: 36.843070000000004,
                  },
                  {
                    lat: -1.30746,
                    lng: 36.843160000000005,
                  },
                  {
                    lat: -1.3075,
                    lng: 36.8432,
                  },
                  {
                    lat: -1.3075100000000002,
                    lng: 36.84322,
                  },
                  {
                    lat: -1.3075400000000001,
                    lng: 36.84326,
                  },
                  {
                    lat: -1.3076100000000002,
                    lng: 36.84335,
                  },
                  {
                    lat: -1.3077100000000002,
                    lng: 36.84349,
                  },
                  {
                    lat: -1.3078200000000002,
                    lng: 36.84364,
                  },
                  {
                    lat: -1.3079200000000002,
                    lng: 36.843790000000006,
                  },
                  {
                    lat: -1.30803,
                    lng: 36.84393,
                  },
                  {
                    lat: -1.30804,
                    lng: 36.84395,
                  },
                  {
                    lat: -1.30813,
                    lng: 36.844080000000005,
                  },
                  {
                    lat: -1.30823,
                    lng: 36.84423,
                  },
                  {
                    lat: -1.30824,
                    lng: 36.844240000000006,
                  },
                  {
                    lat: -1.3083200000000001,
                    lng: 36.844370000000005,
                  },
                  {
                    lat: -1.30837,
                    lng: 36.84445,
                  },
                  {
                    lat: -1.30895,
                    lng: 36.84528,
                  },
                  {
                    lat: -1.30918,
                    lng: 36.84561,
                  },
                  {
                    lat: -1.3098100000000001,
                    lng: 36.84653,
                  },
                  {
                    lat: -1.31014,
                    lng: 36.846990000000005,
                  },
                  {
                    lat: -1.31027,
                    lng: 36.8472,
                  },
                  {
                    lat: -1.31031,
                    lng: 36.847240000000006,
                  },
                  {
                    lat: -1.31048,
                    lng: 36.847500000000004,
                  },
                  {
                    lat: -1.31072,
                    lng: 36.84788,
                  },
                  {
                    lat: -1.3107600000000001,
                    lng: 36.84796,
                  },
                  {
                    lat: -1.31078,
                    lng: 36.84801,
                  },
                  {
                    lat: -1.3108000000000002,
                    lng: 36.8481,
                  },
                  {
                    lat: -1.3110400000000002,
                    lng: 36.84884,
                  },
                  {
                    lat: -1.3110700000000002,
                    lng: 36.84897,
                  },
                  {
                    lat: -1.31108,
                    lng: 36.849030000000006,
                  },
                  {
                    lat: -1.31108,
                    lng: 36.849070000000005,
                  },
                  {
                    lat: -1.31108,
                    lng: 36.849140000000006,
                  },
                  {
                    lat: -1.3110700000000002,
                    lng: 36.849140000000006,
                  },
                  {
                    lat: -1.3110700000000002,
                    lng: 36.84915,
                  },
                  {
                    lat: -1.3110600000000001,
                    lng: 36.84915,
                  },
                  {
                    lat: -1.3110600000000001,
                    lng: 36.849160000000005,
                  },
                  {
                    lat: -1.31105,
                    lng: 36.849160000000005,
                  },
                  {
                    lat: -1.31105,
                    lng: 36.84917,
                  },
                  {
                    lat: -1.3110400000000002,
                    lng: 36.84917,
                  },
                  {
                    lat: -1.3110400000000002,
                    lng: 36.849180000000004,
                  },
                  {
                    lat: -1.3110300000000001,
                    lng: 36.84919,
                  },
                  {
                    lat: -1.3110300000000001,
                    lng: 36.8492,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.84921000000001,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.84922,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.849230000000006,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.84924,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.849250000000005,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.84926,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.849270000000004,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.84928,
                  },
                  {
                    lat: -1.3110300000000001,
                    lng: 36.84929,
                  },
                  {
                    lat: -1.3110300000000001,
                    lng: 36.8493,
                  },
                  {
                    lat: -1.3110300000000001,
                    lng: 36.84931,
                  },
                  {
                    lat: -1.3110400000000002,
                    lng: 36.849320000000006,
                  },
                  {
                    lat: -1.3110400000000002,
                    lng: 36.84933,
                  },
                  {
                    lat: -1.31105,
                    lng: 36.849340000000005,
                  },
                  {
                    lat: -1.3110600000000001,
                    lng: 36.84935,
                  },
                  {
                    lat: -1.3110700000000002,
                    lng: 36.849360000000004,
                  },
                  {
                    lat: -1.31108,
                    lng: 36.849360000000004,
                  },
                  {
                    lat: -1.31108,
                    lng: 36.84937,
                  },
                  {
                    lat: -1.31109,
                    lng: 36.84937,
                  },
                  {
                    lat: -1.3111000000000002,
                    lng: 36.84937,
                  },
                  {
                    lat: -1.3111000000000002,
                    lng: 36.849380000000004,
                  },
                  {
                    lat: -1.31111,
                    lng: 36.849380000000004,
                  },
                  {
                    lat: -1.31112,
                    lng: 36.849380000000004,
                  },
                  {
                    lat: -1.3111300000000001,
                    lng: 36.849380000000004,
                  },
                  {
                    lat: -1.3111400000000002,
                    lng: 36.84939,
                  },
                  {
                    lat: -1.31118,
                    lng: 36.849430000000005,
                  },
                  {
                    lat: -1.3112400000000002,
                    lng: 36.84951,
                  },
                  {
                    lat: -1.3113800000000002,
                    lng: 36.84985,
                  },
                  {
                    lat: -1.31145,
                    lng: 36.850030000000004,
                  },
                ],
                instructions:
                  'At the roundabout, take the <b>1st</b> exit onto <b>Enterprise Rd</b><div style="font-size:0.9em">Go through 2 roundabouts</div><div style="font-size:0.9em">Pass by Mara And Serengeti Expeditions Ltd (on the left)</div>',
                start_point: {
                  lat: -1.3041865,
                  lng: 36.83922990000001,
                },
                end_point: {
                  lat: -1.3114489,
                  lng: 36.8500307,
                },
              },
              {
                distance: {
                  text: "0.6 km",
                  value: 576,
                },
                duration: {
                  text: "1 min",
                  value: 61,
                },
                end_location: {
                  lat: -1.3131121,
                  lng: 36.8549392,
                },
                polyline: {
                  points: "pc_Gug|_F^_Bd@mBR{@BIFWPu@|@oDNi@p@gDhAwEHY",
                },
                start_location: {
                  lat: -1.3114489,
                  lng: 36.8500307,
                },
                travel_mode: "DRIVING",
                encoded_lat_lngs: "pc_Gug|_F^_Bd@mBR{@BIFWPu@|@oDNi@p@gDhAwEHY",
                path: [
                  {
                    lat: -1.31145,
                    lng: 36.850030000000004,
                  },
                  {
                    lat: -1.3116100000000002,
                    lng: 36.85051,
                  },
                  {
                    lat: -1.3118,
                    lng: 36.851060000000004,
                  },
                  {
                    lat: -1.3119,
                    lng: 36.85136,
                  },
                  {
                    lat: -1.3119200000000002,
                    lng: 36.85141,
                  },
                  {
                    lat: -1.31196,
                    lng: 36.851530000000004,
                  },
                  {
                    lat: -1.3120500000000002,
                    lng: 36.851800000000004,
                  },
                  {
                    lat: -1.3123600000000002,
                    lng: 36.85268000000001,
                  },
                  {
                    lat: -1.31244,
                    lng: 36.85289,
                  },
                  {
                    lat: -1.3126900000000001,
                    lng: 36.853730000000006,
                  },
                  {
                    lat: -1.3130600000000001,
                    lng: 36.85481,
                  },
                  {
                    lat: -1.31311,
                    lng: 36.854940000000006,
                  },
                ],
                instructions:
                  'Continue onto <b>Enterprise Road</b><div style="font-size:0.9em">Pass by Joy Enterprises Shop (on the right)</div>',
                maneuver: "",
                start_point: {
                  lat: -1.3114489,
                  lng: 36.8500307,
                },
                end_point: {
                  lat: -1.3131121,
                  lng: 36.8549392,
                },
              },
              {
                distance: {
                  text: "0.4 km",
                  value: 392,
                },
                duration: {
                  text: "1 min",
                  value: 44,
                },
                end_location: {
                  lat: -1.314339,
                  lng: 36.8581644,
                },
                maneuver: "roundabout-left",
                polyline: {
                  points:
                    "|m_Gkf}_FAEAEBWDMDEDCJC?O@G@EDSZmAPq@b@eBPq@XgAR_ANe@FKHSDKNUBI",
                },
                start_location: {
                  lat: -1.3131121,
                  lng: 36.8549392,
                },
                travel_mode: "DRIVING",
                encoded_lat_lngs:
                  "|m_Gkf}_FAEAEBWDMDEDCJC?O@G@EDSZmAPq@b@eBPq@XgAR_ANe@FKHSDKNUBI",
                path: [
                  {
                    lat: -1.31311,
                    lng: 36.854940000000006,
                  },
                  {
                    lat: -1.3131000000000002,
                    lng: 36.85497,
                  },
                  {
                    lat: -1.31309,
                    lng: 36.855000000000004,
                  },
                  {
                    lat: -1.31311,
                    lng: 36.85512000000001,
                  },
                  {
                    lat: -1.3131400000000002,
                    lng: 36.85519,
                  },
                  {
                    lat: -1.3131700000000002,
                    lng: 36.85522,
                  },
                  {
                    lat: -1.3132000000000001,
                    lng: 36.85524,
                  },
                  {
                    lat: -1.31326,
                    lng: 36.85526,
                  },
                  {
                    lat: -1.31326,
                    lng: 36.855340000000005,
                  },
                  {
                    lat: -1.3132700000000002,
                    lng: 36.855380000000004,
                  },
                  {
                    lat: -1.31328,
                    lng: 36.855410000000006,
                  },
                  {
                    lat: -1.3133100000000002,
                    lng: 36.85551,
                  },
                  {
                    lat: -1.31345,
                    lng: 36.855900000000005,
                  },
                  {
                    lat: -1.3135400000000002,
                    lng: 36.85615,
                  },
                  {
                    lat: -1.31372,
                    lng: 36.856660000000005,
                  },
                  {
                    lat: -1.3138100000000001,
                    lng: 36.856910000000006,
                  },
                  {
                    lat: -1.31394,
                    lng: 36.85727,
                  },
                  {
                    lat: -1.31404,
                    lng: 36.85759,
                  },
                  {
                    lat: -1.3141200000000002,
                    lng: 36.857780000000005,
                  },
                  {
                    lat: -1.3141600000000002,
                    lng: 36.85784,
                  },
                  {
                    lat: -1.31421,
                    lng: 36.857940000000006,
                  },
                  {
                    lat: -1.31424,
                    lng: 36.858000000000004,
                  },
                  {
                    lat: -1.3143200000000002,
                    lng: 36.85811,
                  },
                  {
                    lat: -1.31434,
                    lng: 36.858160000000005,
                  },
                ],
                instructions:
                  'At the roundabout, take the <b>2nd</b> exit onto <b>Enterprise Rd</b><div style="font-size:0.9em">Pass by Tetra Pak (on the left)</div><div style="font-size:0.9em">Destination will be on the left</div>',
                start_point: {
                  lat: -1.3131121,
                  lng: 36.8549392,
                },
                end_point: {
                  lat: -1.314339,
                  lng: 36.8581644,
                },
              },
            ],
            traffic_speed_entry: [],
            via_waypoint: [],
            via_waypoints: [],
          },
        ],
        overview_polyline:
          "fs}Fmiz_F`AbCZb@@?B?hBi@l@YLK^i@rA}BpAoBlCmEz@wATe@La@?G?EBMHILCZ]|@sAlBaD`J{NrBqDJYr@eDFe@?UCACCCI?KJQJCFGJOZcAl@cCx@iD\\wAlAyEp@gDhAwEHYAE@]JSPG@WFYbBwGl@gCVq@b@_A",
        summary: "Enterprise Rd",
        warnings: [],
        waypoint_order: [],
        overview_path: [
          {
            lat: -1.3037200000000002,
            lng: 36.840070000000004,
          },
          {
            lat: -1.3040500000000002,
            lng: 36.83941,
          },
          {
            lat: -1.3041900000000002,
            lng: 36.83923,
          },
          {
            lat: -1.3042,
            lng: 36.83923,
          },
          {
            lat: -1.3042200000000002,
            lng: 36.83923,
          },
          {
            lat: -1.30475,
            lng: 36.83944,
          },
          {
            lat: -1.30498,
            lng: 36.83957,
          },
          {
            lat: -1.30505,
            lng: 36.83963,
          },
          {
            lat: -1.3052100000000002,
            lng: 36.83984,
          },
          {
            lat: -1.30563,
            lng: 36.84047,
          },
          {
            lat: -1.30604,
            lng: 36.84103,
          },
          {
            lat: -1.30675,
            lng: 36.842060000000004,
          },
          {
            lat: -1.30705,
            lng: 36.8425,
          },
          {
            lat: -1.30716,
            lng: 36.842690000000005,
          },
          {
            lat: -1.3072300000000001,
            lng: 36.84286,
          },
          {
            lat: -1.3072300000000001,
            lng: 36.8429,
          },
          {
            lat: -1.3072300000000001,
            lng: 36.84293,
          },
          {
            lat: -1.30725,
            lng: 36.843,
          },
          {
            lat: -1.3073000000000001,
            lng: 36.843050000000005,
          },
          {
            lat: -1.3073700000000001,
            lng: 36.843070000000004,
          },
          {
            lat: -1.3075100000000002,
            lng: 36.84322,
          },
          {
            lat: -1.3078200000000002,
            lng: 36.84364,
          },
          {
            lat: -1.30837,
            lng: 36.84445,
          },
          {
            lat: -1.31014,
            lng: 36.846990000000005,
          },
          {
            lat: -1.31072,
            lng: 36.84788,
          },
          {
            lat: -1.31078,
            lng: 36.84801,
          },
          {
            lat: -1.3110400000000002,
            lng: 36.84884,
          },
          {
            lat: -1.31108,
            lng: 36.849030000000006,
          },
          {
            lat: -1.31108,
            lng: 36.849140000000006,
          },
          {
            lat: -1.3110600000000001,
            lng: 36.84915,
          },
          {
            lat: -1.3110400000000002,
            lng: 36.84917,
          },
          {
            lat: -1.31102,
            lng: 36.84922,
          },
          {
            lat: -1.31102,
            lng: 36.84928,
          },
          {
            lat: -1.31108,
            lng: 36.84937,
          },
          {
            lat: -1.3111400000000002,
            lng: 36.84939,
          },
          {
            lat: -1.31118,
            lng: 36.849430000000005,
          },
          {
            lat: -1.3112400000000002,
            lng: 36.84951,
          },
          {
            lat: -1.3113800000000002,
            lng: 36.84985,
          },
          {
            lat: -1.3116100000000002,
            lng: 36.85051,
          },
          {
            lat: -1.3119,
            lng: 36.85136,
          },
          {
            lat: -1.3120500000000002,
            lng: 36.851800000000004,
          },
          {
            lat: -1.31244,
            lng: 36.85289,
          },
          {
            lat: -1.3126900000000001,
            lng: 36.853730000000006,
          },
          {
            lat: -1.3130600000000001,
            lng: 36.85481,
          },
          {
            lat: -1.31311,
            lng: 36.854940000000006,
          },
          {
            lat: -1.3131000000000002,
            lng: 36.85497,
          },
          {
            lat: -1.31311,
            lng: 36.85512000000001,
          },
          {
            lat: -1.3131700000000002,
            lng: 36.85522,
          },
          {
            lat: -1.31326,
            lng: 36.85526,
          },
          {
            lat: -1.3132700000000002,
            lng: 36.855380000000004,
          },
          {
            lat: -1.3133100000000002,
            lng: 36.85551,
          },
          {
            lat: -1.3138100000000001,
            lng: 36.856910000000006,
          },
          {
            lat: -1.31404,
            lng: 36.85759,
          },
          {
            lat: -1.3141600000000002,
            lng: 36.85784,
          },
          {
            lat: -1.31434,
            lng: 36.858160000000005,
          },
        ],
      },
    ],
    status: "OK",
    request: {
      origin: {
        location: {
          lat: -1.303816,
          lng: 36.840122,
        },
      },
      destination: {
        location: {
          lat: -1.314098,
          lng: 36.858274,
        },
      },
      travelMode: "DRIVING",
    },
  },
  {
    geocoded_waypoints: [
      {
        geocoder_status: "OK",
        place_id: "ChIJNdZEPboRLxgR5PeFhsPwm2Q",
        types: [
          "establishment",
          "local_government_office",
          "point_of_interest",
        ],
      },
      {
        geocoder_status: "OK",
        place_id: "ChIJk0qxgoQRLxgRJMpXStqNmSM",
        types: ["establishment", "point_of_interest"],
      },
    ],
    routes: [
      {
        bounds: {
          south: -1.32092,
          west: 36.82621,
          north: -1.2994100000000002,
          east: 36.858160000000005,
        },
        copyrights: "Map data ©2024",
        legs: [
          {
            distance: {
              text: "6.8 km",
              value: 6790,
            },
            duration: {
              text: "12 mins",
              value: 720,
            },
            end_address:
              "PJP Park, Enterprise Rd, Industrial Area, Box 61770 - 00200, Nairobi, Kenya",
            end_location: {
              lat: -1.314339,
              lng: 36.8581644,
            },
            start_address: "MRHQ+J28, Popo Rd, Nairobi, Kenya",
            start_location: {
              lat: -1.3209215,
              lng: 36.8378179,
            },
            steps: [
              {
                distance: {
                  text: "69 m",
                  value: 69,
                },
                duration: {
                  text: "1 min",
                  value: 25,
                },
                end_location: {
                  lat: -1.3205836,
                  lng: 36.8372941,
                },
                polyline: {
                  points: "v~`Gk{y_F[j@g@|@",
                },
                start_location: {
                  lat: -1.3209215,
                  lng: 36.8378179,
                },
                travel_mode: "DRIVING",
                encoded_lat_lngs: "v~`Gk{y_F[j@g@|@",
                path: [
                  {
                    lat: -1.32092,
                    lng: 36.83782,
                  },
                  {
                    lat: -1.32078,
                    lng: 36.8376,
                  },
                  {
                    lat: -1.32058,
                    lng: 36.83729,
                  },
                ],
                instructions: "Head <b>northwest</b> toward <b>Popo Rd</b>",
                maneuver: "",
                start_point: {
                  lat: -1.3209215,
                  lng: 36.8378179,
                },
                end_point: {
                  lat: -1.3205836,
                  lng: 36.8372941,
                },
              },
              {
                distance: {
                  text: "0.1 km",
                  value: 140,
                },
                duration: {
                  text: "1 min",
                  value: 39,
                },
                end_location: {
                  lat: -1.3194714,
                  lng: 36.83784130000001,
                },
                maneuver: "turn-right",
                polyline: {
                  points: "r|`Gaxy_Fw@c@_By@KEMEk@C",
                },
                start_location: {
                  lat: -1.3205836,
                  lng: 36.8372941,
                },
                travel_mode: "DRIVING",
                encoded_lat_lngs: "r|`Gaxy_Fw@c@_By@KEMEk@C",
                path: [
                  {
                    lat: -1.32058,
                    lng: 36.83729,
                  },
                  {
                    lat: -1.3203,
                    lng: 36.83747,
                  },
                  {
                    lat: -1.3198200000000002,
                    lng: 36.83776,
                  },
                  {
                    lat: -1.31976,
                    lng: 36.837790000000005,
                  },
                  {
                    lat: -1.31969,
                    lng: 36.83782,
                  },
                  {
                    lat: -1.3194700000000001,
                    lng: 36.83784,
                  },
                ],
                instructions: "Turn <b>right</b> onto <b>Popo Rd</b>",
                start_point: {
                  lat: -1.3205836,
                  lng: 36.8372941,
                },
                end_point: {
                  lat: -1.3194714,
                  lng: 36.83784130000001,
                },
              },
              {
                distance: {
                  text: "2.1 km",
                  value: 2100,
                },
                duration: {
                  text: "3 mins",
                  value: 167,
                },
                end_location: {
                  lat: -1.3052167,
                  lng: 36.826484,
                },
                maneuver: "turn-left",
                polyline: {
                  points:
                    "tu`Go{y_F]l@MRe@`AEFyAtCGLKRO\\EHe@~@aBjDINGLQ^A@IPQ\\Q\\O^u@vAk@dAQVe@x@e@l@A@a@h@}@dA_@\\_Az@cAv@q@`@oBfAmEhBuAf@oDpAeGxBa@NsDpAeA`@_FdB_@Ls@VMDqBr@cCv@iBn@u@^QJQP",
                },
                start_location: {
                  lat: -1.3194714,
                  lng: 36.83784130000001,
                },
                travel_mode: "DRIVING",
                encoded_lat_lngs:
                  "tu`Go{y_F]l@MRe@`AEFyAtCGLKRO\\EHe@~@aBjDINGLQ^A@IPQ\\Q\\O^u@vAk@dAQVe@x@e@l@A@a@h@}@dA_@\\_Az@cAv@q@`@oBfAmEhBuAf@oDpAeGxBa@NsDpAeA`@_FdB_@Ls@VMDqBr@cCv@iBn@u@^QJQP",
                path: [
                  {
                    lat: -1.3194700000000001,
                    lng: 36.83784,
                  },
                  {
                    lat: -1.31932,
                    lng: 36.837610000000005,
                  },
                  {
                    lat: -1.31925,
                    lng: 36.83751,
                  },
                  {
                    lat: -1.3190600000000001,
                    lng: 36.837180000000004,
                  },
                  {
                    lat: -1.3190300000000001,
                    lng: 36.837140000000005,
                  },
                  {
                    lat: -1.31858,
                    lng: 36.83639,
                  },
                  {
                    lat: -1.31854,
                    lng: 36.83632,
                  },
                  {
                    lat: -1.31848,
                    lng: 36.836220000000004,
                  },
                  {
                    lat: -1.3184,
                    lng: 36.83607000000001,
                  },
                  {
                    lat: -1.31837,
                    lng: 36.836020000000005,
                  },
                  {
                    lat: -1.3181800000000001,
                    lng: 36.8357,
                  },
                  {
                    lat: -1.31769,
                    lng: 36.83484,
                  },
                  {
                    lat: -1.3176400000000001,
                    lng: 36.83476,
                  },
                  {
                    lat: -1.3176,
                    lng: 36.83469,
                  },
                  {
                    lat: -1.3175100000000002,
                    lng: 36.83453,
                  },
                  {
                    lat: -1.3175000000000001,
                    lng: 36.834520000000005,
                  },
                  {
                    lat: -1.31745,
                    lng: 36.834430000000005,
                  },
                  {
                    lat: -1.31736,
                    lng: 36.83428,
                  },
                  {
                    lat: -1.3172700000000002,
                    lng: 36.83413,
                  },
                  {
                    lat: -1.31719,
                    lng: 36.83397,
                  },
                  {
                    lat: -1.31692,
                    lng: 36.83353,
                  },
                  {
                    lat: -1.3167000000000002,
                    lng: 36.833180000000006,
                  },
                  {
                    lat: -1.31661,
                    lng: 36.83306,
                  },
                  {
                    lat: -1.3164200000000001,
                    lng: 36.832770000000004,
                  },
                  {
                    lat: -1.31623,
                    lng: 36.83254,
                  },
                  {
                    lat: -1.3162200000000002,
                    lng: 36.832530000000006,
                  },
                  {
                    lat: -1.3160500000000002,
                    lng: 36.83232,
                  },
                  {
                    lat: -1.3157400000000001,
                    lng: 36.831970000000005,
                  },
                  {
                    lat: -1.3155800000000002,
                    lng: 36.83182,
                  },
                  {
                    lat: -1.31526,
                    lng: 36.831520000000005,
                  },
                  {
                    lat: -1.31492,
                    lng: 36.83124,
                  },
                  {
                    lat: -1.31467,
                    lng: 36.831070000000004,
                  },
                  {
                    lat: -1.3141100000000001,
                    lng: 36.83071,
                  },
                  {
                    lat: -1.31308,
                    lng: 36.830180000000006,
                  },
                  {
                    lat: -1.31265,
                    lng: 36.829980000000006,
                  },
                  {
                    lat: -1.31177,
                    lng: 36.829570000000004,
                  },
                  {
                    lat: -1.3104600000000002,
                    lng: 36.82896,
                  },
                  {
                    lat: -1.3102900000000002,
                    lng: 36.828880000000005,
                  },
                  {
                    lat: -1.30939,
                    lng: 36.82847,
                  },
                  {
                    lat: -1.3090400000000002,
                    lng: 36.828300000000006,
                  },
                  {
                    lat: -1.3079200000000002,
                    lng: 36.82779,
                  },
                  {
                    lat: -1.30776,
                    lng: 36.82772000000001,
                  },
                  {
                    lat: -1.3075,
                    lng: 36.827600000000004,
                  },
                  {
                    lat: -1.30743,
                    lng: 36.82757,
                  },
                  {
                    lat: -1.3068600000000001,
                    lng: 36.827310000000004,
                  },
                  {
                    lat: -1.3062,
                    lng: 36.82703,
                  },
                  {
                    lat: -1.30567,
                    lng: 36.82679,
                  },
                  {
                    lat: -1.3054000000000001,
                    lng: 36.82663,
                  },
                  {
                    lat: -1.3053100000000002,
                    lng: 36.826570000000004,
                  },
                  {
                    lat: -1.30522,
                    lng: 36.826480000000004,
                  },
                ],
                instructions:
                  'Turn <b>left</b> onto <b>Mombasa Road</b>/<wbr/><b>A104</b><div style="font-size:0.9em">Pass by Kenya Institute Of Mass Communication (on the right in 1.3 km)</div>',
                start_point: {
                  lat: -1.3194714,
                  lng: 36.83784130000001,
                },
                end_point: {
                  lat: -1.3052167,
                  lng: 36.826484,
                },
              },
              {
                distance: {
                  text: "0.7 km",
                  value: 680,
                },
                duration: {
                  text: "1 min",
                  value: 83,
                },
                end_location: {
                  lat: -1.3024163,
                  lng: 36.8311582,
                },
                maneuver: "roundabout-left",
                polyline: {
                  points:
                    "r|}Fotw_F?@AB?B?@ABAB?@ABCDEDEBEBEBG@G@I?C?C?C?CAAAC?CACAEEEECECEAEAGAG?G@G?A?A@C?A@A?C@A@A[aAg@wAK]Qc@e@oAEMw@kBa@eAwAmDYk@Ug@IS[s@Q_@OYKS",
                },
                start_location: {
                  lat: -1.3052167,
                  lng: 36.826484,
                },
                travel_mode: "DRIVING",
                encoded_lat_lngs:
                  "r|}Fotw_F?@AB?B?@ABAB?@ABCDEDEBEBEBG@G@I?C?C?C?CAAAC?CACAEEEECECEAEAGAG?G@G?A?A@C?A@A?C@A@A[aAg@wAK]Qc@e@oAEMw@kBa@eAwAmDYk@Ug@IS[s@Q_@OYKS",
                path: [
                  {
                    lat: -1.30522,
                    lng: 36.826480000000004,
                  },
                  {
                    lat: -1.30522,
                    lng: 36.82647,
                  },
                  {
                    lat: -1.3052100000000002,
                    lng: 36.82645,
                  },
                  {
                    lat: -1.3052100000000002,
                    lng: 36.82643,
                  },
                  {
                    lat: -1.3052100000000002,
                    lng: 36.826420000000006,
                  },
                  {
                    lat: -1.3052000000000001,
                    lng: 36.8264,
                  },
                  {
                    lat: -1.30519,
                    lng: 36.82638,
                  },
                  {
                    lat: -1.30519,
                    lng: 36.826370000000004,
                  },
                  {
                    lat: -1.30518,
                    lng: 36.826350000000005,
                  },
                  {
                    lat: -1.30516,
                    lng: 36.82632,
                  },
                  {
                    lat: -1.3051300000000001,
                    lng: 36.82629,
                  },
                  {
                    lat: -1.3051000000000001,
                    lng: 36.82627,
                  },
                  {
                    lat: -1.3050700000000002,
                    lng: 36.82625,
                  },
                  {
                    lat: -1.3050400000000002,
                    lng: 36.82623,
                  },
                  {
                    lat: -1.3050000000000002,
                    lng: 36.826220000000006,
                  },
                  {
                    lat: -1.3049600000000001,
                    lng: 36.82621,
                  },
                  {
                    lat: -1.30491,
                    lng: 36.82621,
                  },
                  {
                    lat: -1.30489,
                    lng: 36.82621,
                  },
                  {
                    lat: -1.3048700000000002,
                    lng: 36.82621,
                  },
                  {
                    lat: -1.30485,
                    lng: 36.82621,
                  },
                  {
                    lat: -1.3048300000000002,
                    lng: 36.826220000000006,
                  },
                  {
                    lat: -1.30482,
                    lng: 36.82623,
                  },
                  {
                    lat: -1.3048000000000002,
                    lng: 36.82623,
                  },
                  {
                    lat: -1.30478,
                    lng: 36.826240000000006,
                  },
                  {
                    lat: -1.3047600000000001,
                    lng: 36.82625,
                  },
                  {
                    lat: -1.3047300000000002,
                    lng: 36.826280000000004,
                  },
                  {
                    lat: -1.3047000000000002,
                    lng: 36.82631000000001,
                  },
                  {
                    lat: -1.30468,
                    lng: 36.82634,
                  },
                  {
                    lat: -1.3046600000000002,
                    lng: 36.826370000000004,
                  },
                  {
                    lat: -1.30465,
                    lng: 36.8264,
                  },
                  {
                    lat: -1.30464,
                    lng: 36.826440000000005,
                  },
                  {
                    lat: -1.3046300000000002,
                    lng: 36.826480000000004,
                  },
                  {
                    lat: -1.3046300000000002,
                    lng: 36.82652,
                  },
                  {
                    lat: -1.30464,
                    lng: 36.82656,
                  },
                  {
                    lat: -1.30464,
                    lng: 36.826570000000004,
                  },
                  {
                    lat: -1.30464,
                    lng: 36.82658,
                  },
                  {
                    lat: -1.30465,
                    lng: 36.826600000000006,
                  },
                  {
                    lat: -1.30465,
                    lng: 36.82661,
                  },
                  {
                    lat: -1.3046600000000002,
                    lng: 36.826620000000005,
                  },
                  {
                    lat: -1.3046600000000002,
                    lng: 36.826640000000005,
                  },
                  {
                    lat: -1.30467,
                    lng: 36.82665,
                  },
                  {
                    lat: -1.30468,
                    lng: 36.826660000000004,
                  },
                  {
                    lat: -1.30454,
                    lng: 36.82699,
                  },
                  {
                    lat: -1.30434,
                    lng: 36.82743,
                  },
                  {
                    lat: -1.30428,
                    lng: 36.827580000000005,
                  },
                  {
                    lat: -1.3041900000000002,
                    lng: 36.827760000000005,
                  },
                  {
                    lat: -1.304,
                    lng: 36.828160000000004,
                  },
                  {
                    lat: -1.30397,
                    lng: 36.828230000000005,
                  },
                  {
                    lat: -1.30369,
                    lng: 36.828770000000006,
                  },
                  {
                    lat: -1.30352,
                    lng: 36.82912,
                  },
                  {
                    lat: -1.30308,
                    lng: 36.82999,
                  },
                  {
                    lat: -1.30295,
                    lng: 36.83021,
                  },
                  {
                    lat: -1.30284,
                    lng: 36.83041,
                  },
                  {
                    lat: -1.3027900000000001,
                    lng: 36.830510000000004,
                  },
                  {
                    lat: -1.30265,
                    lng: 36.83077,
                  },
                  {
                    lat: -1.3025600000000002,
                    lng: 36.83093,
                  },
                  {
                    lat: -1.30248,
                    lng: 36.83106,
                  },
                  {
                    lat: -1.3024200000000001,
                    lng: 36.831160000000004,
                  },
                ],
                instructions:
                  'At the roundabout, take the <b>3rd</b> exit onto <b>Lusaka Rd</b><div style="font-size:0.9em">Pass by DHL House (on the right)</div>',
                start_point: {
                  lat: -1.3052167,
                  lng: 36.826484,
                },
                end_point: {
                  lat: -1.3024163,
                  lng: 36.8311582,
                },
              },
              {
                distance: {
                  text: "0.7 km",
                  value: 682,
                },
                duration: {
                  text: "1 min",
                  value: 69,
                },
                end_location: {
                  lat: -1.2996832,
                  lng: 36.8365618,
                },
                maneuver: "roundabout-left",
                polyline: {
                  points:
                    "bk}Fwqx_FC?A?AAA?A?AAC?AAAAA?AA?AAAACAA?AAA?A?C?A?C?A?E@CBGK[g@qAoAcD_AcCs@gBEMw@sBiAuCg@mAGOMY]s@MWKOQU",
                },
                start_location: {
                  lat: -1.3024163,
                  lng: 36.8311582,
                },
                travel_mode: "DRIVING",
                encoded_lat_lngs:
                  "bk}Fwqx_FC?A?AAA?A?AAC?AAAAA?AA?AAAACAA?AAA?A?C?A?C?A?E@CBGK[g@qAoAcD_AcCs@gBEMw@sBiAuCg@mAGOMY]s@MWKOQU",
                path: [
                  {
                    lat: -1.3024200000000001,
                    lng: 36.831160000000004,
                  },
                  {
                    lat: -1.3024,
                    lng: 36.831160000000004,
                  },
                  {
                    lat: -1.3023900000000002,
                    lng: 36.831160000000004,
                  },
                  {
                    lat: -1.30238,
                    lng: 36.83117,
                  },
                  {
                    lat: -1.30237,
                    lng: 36.83117,
                  },
                  {
                    lat: -1.3023600000000002,
                    lng: 36.83117,
                  },
                  {
                    lat: -1.3023500000000001,
                    lng: 36.83118,
                  },
                  {
                    lat: -1.3023300000000002,
                    lng: 36.83118,
                  },
                  {
                    lat: -1.3023200000000001,
                    lng: 36.83119000000001,
                  },
                  {
                    lat: -1.30231,
                    lng: 36.8312,
                  },
                  {
                    lat: -1.3023,
                    lng: 36.8312,
                  },
                  {
                    lat: -1.3022900000000002,
                    lng: 36.831210000000006,
                  },
                  {
                    lat: -1.3022900000000002,
                    lng: 36.83122,
                  },
                  {
                    lat: -1.30228,
                    lng: 36.831230000000005,
                  },
                  {
                    lat: -1.30227,
                    lng: 36.831250000000004,
                  },
                  {
                    lat: -1.3022600000000002,
                    lng: 36.83126,
                  },
                  {
                    lat: -1.3022600000000002,
                    lng: 36.83127,
                  },
                  {
                    lat: -1.3022500000000001,
                    lng: 36.83128,
                  },
                  {
                    lat: -1.3022500000000001,
                    lng: 36.83129,
                  },
                  {
                    lat: -1.3022500000000001,
                    lng: 36.83131,
                  },
                  {
                    lat: -1.3022500000000001,
                    lng: 36.831320000000005,
                  },
                  {
                    lat: -1.3022500000000001,
                    lng: 36.831340000000004,
                  },
                  {
                    lat: -1.3022500000000001,
                    lng: 36.83135,
                  },
                  {
                    lat: -1.3022500000000001,
                    lng: 36.83138,
                  },
                  {
                    lat: -1.3022600000000002,
                    lng: 36.8314,
                  },
                  {
                    lat: -1.30228,
                    lng: 36.83144,
                  },
                  {
                    lat: -1.3022200000000002,
                    lng: 36.83158,
                  },
                  {
                    lat: -1.3020200000000002,
                    lng: 36.831990000000005,
                  },
                  {
                    lat: -1.30162,
                    lng: 36.83281,
                  },
                  {
                    lat: -1.3013000000000001,
                    lng: 36.833470000000005,
                  },
                  {
                    lat: -1.3010400000000002,
                    lng: 36.83399,
                  },
                  {
                    lat: -1.30101,
                    lng: 36.83406,
                  },
                  {
                    lat: -1.3007300000000002,
                    lng: 36.83464,
                  },
                  {
                    lat: -1.3003600000000002,
                    lng: 36.835390000000004,
                  },
                  {
                    lat: -1.3001600000000002,
                    lng: 36.83578,
                  },
                  {
                    lat: -1.3001200000000002,
                    lng: 36.835860000000004,
                  },
                  {
                    lat: -1.3000500000000001,
                    lng: 36.83599,
                  },
                  {
                    lat: -1.2999,
                    lng: 36.83625,
                  },
                  {
                    lat: -1.29983,
                    lng: 36.83637,
                  },
                  {
                    lat: -1.29977,
                    lng: 36.836450000000006,
                  },
                  {
                    lat: -1.2996800000000002,
                    lng: 36.836560000000006,
                  },
                ],
                instructions:
                  "At the roundabout, take the <b>2nd</b> exit and stay on <b>Lusaka Rd</b>",
                start_point: {
                  lat: -1.3024163,
                  lng: 36.8311582,
                },
                end_point: {
                  lat: -1.2996832,
                  lng: 36.8365618,
                },
              },
              {
                distance: {
                  text: "2.2 km",
                  value: 2151,
                },
                duration: {
                  text: "4 mins",
                  value: 232,
                },
                end_location: {
                  lat: -1.3114489,
                  lng: 36.8500307,
                },
                maneuver: "roundabout-left",
                polyline: {
                  points:
                    "~y|Fosy_FC?EACACAEACACACCACCAACACACACAC?CAC?A?A?C?A?C?A?A@G@GBEBEBEDEDCDCLAFAF?F@F@FBFDDBRERI`A_@t@YdBq@bDmA^OnAi@dBu@~B_AZM`@S?A?A@A?A@A@A?A@?@A@?@A@?@A@?@?@?@?@?@?@@pAa@TINEJGBALIFEDEHKT]b@y@n@cAh@y@f@u@|@_BnAmBf@w@R_@NWDMDIFW?A?A?A?A?A?A?A?C@C@A?C@A@ABC@ABA@?@A@?@?@?@?NQFG@CDGLQR[T]R]T[@CPYR]@ANYHOrBeDl@aA|BwD`A{AXi@FG`@s@n@kAFOBIBQn@sCDY@K?G?MA??AA??AA??AA??AAA?AAA?A?A?A?A?A?A?A@A?A?A@A?A@A@A@A@??A@?@??A@?@?@?@AFGJOZcALc@",
                },
                start_location: {
                  lat: -1.2996832,
                  lng: 36.8365618,
                },
                travel_mode: "DRIVING",
                encoded_lat_lngs:
                  "~y|Fosy_FC?EACACAEACACACCACCAACACACACAC?CAC?A?A?C?A?C?A?A@G@GBEBEBEDEDCDCLAFAF?F@F@FBFDDBRERI`A_@t@YdBq@bDmA^OnAi@dBu@~B_AZM`@S?A?A@A?A@A@A?A@?@A@?@A@?@A@?@?@?@?@?@?@@pAa@TINEJGBALIFEDEHKT]b@y@n@cAh@y@f@u@|@_BnAmBf@w@R_@NWDMDIFW?A?A?A?A?A?A?A?C@C@A?C@A@ABC@ABA@?@A@?@?@?@?NQFG@CDGLQR[T]R]T[@CPYR]@ANYHOrBeDl@aA|BwD`A{AXi@FG`@s@n@kAFOBIBQn@sCDY@K?G?MA??AA??AA??AA??AAA?AAA?A?A?A?A?A?A?A@A?A?A@A?A@A@A@A@??A@?@??A@?@?@?@AFGJOZcALc@",
                path: [
                  {
                    lat: -1.2996800000000002,
                    lng: 36.836560000000006,
                  },
                  {
                    lat: -1.29966,
                    lng: 36.836560000000006,
                  },
                  {
                    lat: -1.29963,
                    lng: 36.83657,
                  },
                  {
                    lat: -1.2996100000000002,
                    lng: 36.836580000000005,
                  },
                  {
                    lat: -1.29959,
                    lng: 36.83659,
                  },
                  {
                    lat: -1.29956,
                    lng: 36.836600000000004,
                  },
                  {
                    lat: -1.2995400000000001,
                    lng: 36.83661,
                  },
                  {
                    lat: -1.29952,
                    lng: 36.83662,
                  },
                  {
                    lat: -1.2995,
                    lng: 36.83664,
                  },
                  {
                    lat: -1.29949,
                    lng: 36.83666,
                  },
                  {
                    lat: -1.2994700000000001,
                    lng: 36.836670000000005,
                  },
                  {
                    lat: -1.29946,
                    lng: 36.836690000000004,
                  },
                  {
                    lat: -1.2994500000000002,
                    lng: 36.836710000000004,
                  },
                  {
                    lat: -1.2994400000000002,
                    lng: 36.83673,
                  },
                  {
                    lat: -1.29943,
                    lng: 36.83675,
                  },
                  {
                    lat: -1.29942,
                    lng: 36.83677,
                  },
                  {
                    lat: -1.29942,
                    lng: 36.83679,
                  },
                  {
                    lat: -1.2994100000000002,
                    lng: 36.83681,
                  },
                  {
                    lat: -1.2994100000000002,
                    lng: 36.83682,
                  },
                  {
                    lat: -1.2994100000000002,
                    lng: 36.836830000000006,
                  },
                  {
                    lat: -1.2994100000000002,
                    lng: 36.836850000000005,
                  },
                  {
                    lat: -1.2994100000000002,
                    lng: 36.83686,
                  },
                  {
                    lat: -1.2994100000000002,
                    lng: 36.83688,
                  },
                  {
                    lat: -1.2994100000000002,
                    lng: 36.836890000000004,
                  },
                  {
                    lat: -1.2994100000000002,
                    lng: 36.8369,
                  },
                  {
                    lat: -1.29942,
                    lng: 36.836940000000006,
                  },
                  {
                    lat: -1.29943,
                    lng: 36.836980000000004,
                  },
                  {
                    lat: -1.2994500000000002,
                    lng: 36.83701000000001,
                  },
                  {
                    lat: -1.2994700000000001,
                    lng: 36.83704,
                  },
                  {
                    lat: -1.29949,
                    lng: 36.837070000000004,
                  },
                  {
                    lat: -1.29952,
                    lng: 36.8371,
                  },
                  {
                    lat: -1.2995500000000002,
                    lng: 36.837120000000006,
                  },
                  {
                    lat: -1.2995800000000002,
                    lng: 36.837140000000005,
                  },
                  {
                    lat: -1.2996500000000002,
                    lng: 36.83715,
                  },
                  {
                    lat: -1.29969,
                    lng: 36.837160000000004,
                  },
                  {
                    lat: -1.29973,
                    lng: 36.837160000000004,
                  },
                  {
                    lat: -1.29977,
                    lng: 36.83715,
                  },
                  {
                    lat: -1.2998100000000001,
                    lng: 36.837140000000005,
                  },
                  {
                    lat: -1.2998500000000002,
                    lng: 36.837120000000006,
                  },
                  {
                    lat: -1.2998900000000002,
                    lng: 36.83709,
                  },
                  {
                    lat: -1.2999200000000002,
                    lng: 36.837070000000004,
                  },
                  {
                    lat: -1.3000200000000002,
                    lng: 36.8371,
                  },
                  {
                    lat: -1.3001200000000002,
                    lng: 36.83715,
                  },
                  {
                    lat: -1.30045,
                    lng: 36.83731,
                  },
                  {
                    lat: -1.30072,
                    lng: 36.83744,
                  },
                  {
                    lat: -1.30123,
                    lng: 36.83769,
                  },
                  {
                    lat: -1.3020500000000002,
                    lng: 36.838080000000005,
                  },
                  {
                    lat: -1.30221,
                    lng: 36.83816,
                  },
                  {
                    lat: -1.30261,
                    lng: 36.838370000000005,
                  },
                  {
                    lat: -1.30312,
                    lng: 36.838640000000005,
                  },
                  {
                    lat: -1.30376,
                    lng: 36.83896,
                  },
                  {
                    lat: -1.3039,
                    lng: 36.83903,
                  },
                  {
                    lat: -1.30407,
                    lng: 36.839130000000004,
                  },
                  {
                    lat: -1.30407,
                    lng: 36.83914,
                  },
                  {
                    lat: -1.30407,
                    lng: 36.839150000000004,
                  },
                  {
                    lat: -1.3040800000000001,
                    lng: 36.83916,
                  },
                  {
                    lat: -1.3040800000000001,
                    lng: 36.83917,
                  },
                  {
                    lat: -1.3040900000000002,
                    lng: 36.839180000000006,
                  },
                  {
                    lat: -1.3041,
                    lng: 36.83919,
                  },
                  {
                    lat: -1.3041,
                    lng: 36.839200000000005,
                  },
                  {
                    lat: -1.30411,
                    lng: 36.839200000000005,
                  },
                  {
                    lat: -1.3041200000000002,
                    lng: 36.83921,
                  },
                  {
                    lat: -1.30413,
                    lng: 36.83921,
                  },
                  {
                    lat: -1.30414,
                    lng: 36.839220000000005,
                  },
                  {
                    lat: -1.3041500000000001,
                    lng: 36.839220000000005,
                  },
                  {
                    lat: -1.3041600000000002,
                    lng: 36.83923,
                  },
                  {
                    lat: -1.30417,
                    lng: 36.83923,
                  },
                  {
                    lat: -1.3041800000000001,
                    lng: 36.83923,
                  },
                  {
                    lat: -1.3041900000000002,
                    lng: 36.83923,
                  },
                  {
                    lat: -1.3042,
                    lng: 36.83923,
                  },
                  {
                    lat: -1.30421,
                    lng: 36.83923,
                  },
                  {
                    lat: -1.3042200000000002,
                    lng: 36.83923,
                  },
                  {
                    lat: -1.30423,
                    lng: 36.839220000000005,
                  },
                  {
                    lat: -1.30464,
                    lng: 36.83939,
                  },
                  {
                    lat: -1.30475,
                    lng: 36.83944,
                  },
                  {
                    lat: -1.3048300000000002,
                    lng: 36.839470000000006,
                  },
                  {
                    lat: -1.30489,
                    lng: 36.839510000000004,
                  },
                  {
                    lat: -1.30491,
                    lng: 36.83952,
                  },
                  {
                    lat: -1.30498,
                    lng: 36.83957,
                  },
                  {
                    lat: -1.30502,
                    lng: 36.839600000000004,
                  },
                  {
                    lat: -1.30505,
                    lng: 36.83963,
                  },
                  {
                    lat: -1.3051000000000001,
                    lng: 36.839690000000004,
                  },
                  {
                    lat: -1.3052100000000002,
                    lng: 36.83984,
                  },
                  {
                    lat: -1.30539,
                    lng: 36.84013,
                  },
                  {
                    lat: -1.30563,
                    lng: 36.84047,
                  },
                  {
                    lat: -1.3058400000000001,
                    lng: 36.84076,
                  },
                  {
                    lat: -1.30604,
                    lng: 36.84103,
                  },
                  {
                    lat: -1.3063500000000001,
                    lng: 36.84151,
                  },
                  {
                    lat: -1.30675,
                    lng: 36.842060000000004,
                  },
                  {
                    lat: -1.30695,
                    lng: 36.84234,
                  },
                  {
                    lat: -1.30705,
                    lng: 36.8425,
                  },
                  {
                    lat: -1.3071300000000001,
                    lng: 36.842620000000004,
                  },
                  {
                    lat: -1.30716,
                    lng: 36.842690000000005,
                  },
                  {
                    lat: -1.30719,
                    lng: 36.842740000000006,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.84286,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.842870000000005,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.84288,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.842890000000004,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.8429,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.84291,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.84292000000001,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.84293,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.84295,
                  },
                  {
                    lat: -1.3072400000000002,
                    lng: 36.84297,
                  },
                  {
                    lat: -1.30725,
                    lng: 36.842980000000004,
                  },
                  {
                    lat: -1.30725,
                    lng: 36.843,
                  },
                  {
                    lat: -1.30726,
                    lng: 36.84301,
                  },
                  {
                    lat: -1.3072700000000002,
                    lng: 36.84302,
                  },
                  {
                    lat: -1.30729,
                    lng: 36.84304,
                  },
                  {
                    lat: -1.3073000000000001,
                    lng: 36.843050000000005,
                  },
                  {
                    lat: -1.30732,
                    lng: 36.84306,
                  },
                  {
                    lat: -1.30733,
                    lng: 36.84306,
                  },
                  {
                    lat: -1.3073400000000002,
                    lng: 36.843070000000004,
                  },
                  {
                    lat: -1.30735,
                    lng: 36.843070000000004,
                  },
                  {
                    lat: -1.30736,
                    lng: 36.843070000000004,
                  },
                  {
                    lat: -1.3073700000000001,
                    lng: 36.843070000000004,
                  },
                  {
                    lat: -1.3073800000000002,
                    lng: 36.843070000000004,
                  },
                  {
                    lat: -1.30746,
                    lng: 36.843160000000005,
                  },
                  {
                    lat: -1.3075,
                    lng: 36.8432,
                  },
                  {
                    lat: -1.3075100000000002,
                    lng: 36.84322,
                  },
                  {
                    lat: -1.3075400000000001,
                    lng: 36.84326,
                  },
                  {
                    lat: -1.3076100000000002,
                    lng: 36.84335,
                  },
                  {
                    lat: -1.3077100000000002,
                    lng: 36.84349,
                  },
                  {
                    lat: -1.3078200000000002,
                    lng: 36.84364,
                  },
                  {
                    lat: -1.3079200000000002,
                    lng: 36.843790000000006,
                  },
                  {
                    lat: -1.30803,
                    lng: 36.84393,
                  },
                  {
                    lat: -1.30804,
                    lng: 36.84395,
                  },
                  {
                    lat: -1.30813,
                    lng: 36.844080000000005,
                  },
                  {
                    lat: -1.30823,
                    lng: 36.84423,
                  },
                  {
                    lat: -1.30824,
                    lng: 36.844240000000006,
                  },
                  {
                    lat: -1.3083200000000001,
                    lng: 36.844370000000005,
                  },
                  {
                    lat: -1.30837,
                    lng: 36.84445,
                  },
                  {
                    lat: -1.30895,
                    lng: 36.84528,
                  },
                  {
                    lat: -1.30918,
                    lng: 36.84561,
                  },
                  {
                    lat: -1.3098100000000001,
                    lng: 36.84653,
                  },
                  {
                    lat: -1.31014,
                    lng: 36.846990000000005,
                  },
                  {
                    lat: -1.31027,
                    lng: 36.8472,
                  },
                  {
                    lat: -1.31031,
                    lng: 36.847240000000006,
                  },
                  {
                    lat: -1.31048,
                    lng: 36.847500000000004,
                  },
                  {
                    lat: -1.31072,
                    lng: 36.84788,
                  },
                  {
                    lat: -1.3107600000000001,
                    lng: 36.84796,
                  },
                  {
                    lat: -1.31078,
                    lng: 36.84801,
                  },
                  {
                    lat: -1.3108000000000002,
                    lng: 36.8481,
                  },
                  {
                    lat: -1.3110400000000002,
                    lng: 36.84884,
                  },
                  {
                    lat: -1.3110700000000002,
                    lng: 36.84897,
                  },
                  {
                    lat: -1.31108,
                    lng: 36.849030000000006,
                  },
                  {
                    lat: -1.31108,
                    lng: 36.849070000000005,
                  },
                  {
                    lat: -1.31108,
                    lng: 36.849140000000006,
                  },
                  {
                    lat: -1.3110700000000002,
                    lng: 36.849140000000006,
                  },
                  {
                    lat: -1.3110700000000002,
                    lng: 36.84915,
                  },
                  {
                    lat: -1.3110600000000001,
                    lng: 36.84915,
                  },
                  {
                    lat: -1.3110600000000001,
                    lng: 36.849160000000005,
                  },
                  {
                    lat: -1.31105,
                    lng: 36.849160000000005,
                  },
                  {
                    lat: -1.31105,
                    lng: 36.84917,
                  },
                  {
                    lat: -1.3110400000000002,
                    lng: 36.84917,
                  },
                  {
                    lat: -1.3110400000000002,
                    lng: 36.849180000000004,
                  },
                  {
                    lat: -1.3110300000000001,
                    lng: 36.84919,
                  },
                  {
                    lat: -1.3110300000000001,
                    lng: 36.8492,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.84921000000001,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.84922,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.849230000000006,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.84924,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.849250000000005,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.84926,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.849270000000004,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.84928,
                  },
                  {
                    lat: -1.3110300000000001,
                    lng: 36.84929,
                  },
                  {
                    lat: -1.3110300000000001,
                    lng: 36.8493,
                  },
                  {
                    lat: -1.3110300000000001,
                    lng: 36.84931,
                  },
                  {
                    lat: -1.3110400000000002,
                    lng: 36.849320000000006,
                  },
                  {
                    lat: -1.3110400000000002,
                    lng: 36.84933,
                  },
                  {
                    lat: -1.31105,
                    lng: 36.849340000000005,
                  },
                  {
                    lat: -1.3110600000000001,
                    lng: 36.84935,
                  },
                  {
                    lat: -1.3110700000000002,
                    lng: 36.849360000000004,
                  },
                  {
                    lat: -1.31108,
                    lng: 36.849360000000004,
                  },
                  {
                    lat: -1.31108,
                    lng: 36.84937,
                  },
                  {
                    lat: -1.31109,
                    lng: 36.84937,
                  },
                  {
                    lat: -1.3111000000000002,
                    lng: 36.84937,
                  },
                  {
                    lat: -1.3111000000000002,
                    lng: 36.849380000000004,
                  },
                  {
                    lat: -1.31111,
                    lng: 36.849380000000004,
                  },
                  {
                    lat: -1.31112,
                    lng: 36.849380000000004,
                  },
                  {
                    lat: -1.3111300000000001,
                    lng: 36.849380000000004,
                  },
                  {
                    lat: -1.3111400000000002,
                    lng: 36.84939,
                  },
                  {
                    lat: -1.31118,
                    lng: 36.849430000000005,
                  },
                  {
                    lat: -1.3112400000000002,
                    lng: 36.84951,
                  },
                  {
                    lat: -1.3113800000000002,
                    lng: 36.84985,
                  },
                  {
                    lat: -1.31145,
                    lng: 36.850030000000004,
                  },
                ],
                instructions:
                  'At the roundabout, take the <b>3rd</b> exit onto <b>Enterprise Rd</b><div style="font-size:0.9em">Pass by Remand Prison (on the right)</div>',
                start_point: {
                  lat: -1.2996832,
                  lng: 36.8365618,
                },
                end_point: {
                  lat: -1.3114489,
                  lng: 36.8500307,
                },
              },
              {
                distance: {
                  text: "0.6 km",
                  value: 576,
                },
                duration: {
                  text: "1 min",
                  value: 61,
                },
                end_location: {
                  lat: -1.3131121,
                  lng: 36.8549392,
                },
                polyline: {
                  points: "pc_Gug|_F^_Bd@mBR{@BIFWPu@|@oDNi@p@gDhAwEHY",
                },
                start_location: {
                  lat: -1.3114489,
                  lng: 36.8500307,
                },
                travel_mode: "DRIVING",
                encoded_lat_lngs: "pc_Gug|_F^_Bd@mBR{@BIFWPu@|@oDNi@p@gDhAwEHY",
                path: [
                  {
                    lat: -1.31145,
                    lng: 36.850030000000004,
                  },
                  {
                    lat: -1.3116100000000002,
                    lng: 36.85051,
                  },
                  {
                    lat: -1.3118,
                    lng: 36.851060000000004,
                  },
                  {
                    lat: -1.3119,
                    lng: 36.85136,
                  },
                  {
                    lat: -1.3119200000000002,
                    lng: 36.85141,
                  },
                  {
                    lat: -1.31196,
                    lng: 36.851530000000004,
                  },
                  {
                    lat: -1.3120500000000002,
                    lng: 36.851800000000004,
                  },
                  {
                    lat: -1.3123600000000002,
                    lng: 36.85268000000001,
                  },
                  {
                    lat: -1.31244,
                    lng: 36.85289,
                  },
                  {
                    lat: -1.3126900000000001,
                    lng: 36.853730000000006,
                  },
                  {
                    lat: -1.3130600000000001,
                    lng: 36.85481,
                  },
                  {
                    lat: -1.31311,
                    lng: 36.854940000000006,
                  },
                ],
                instructions: "Continue onto <b>Enterprise Road</b>",
                maneuver: "",
                start_point: {
                  lat: -1.3114489,
                  lng: 36.8500307,
                },
                end_point: {
                  lat: -1.3131121,
                  lng: 36.8549392,
                },
              },
              {
                distance: {
                  text: "0.4 km",
                  value: 392,
                },
                duration: {
                  text: "1 min",
                  value: 44,
                },
                end_location: {
                  lat: -1.314339,
                  lng: 36.8581644,
                },
                maneuver: "roundabout-left",
                polyline: {
                  points:
                    "|m_Gkf}_FAEAEBWDMDEDCJC?O@G@EDSZmAPq@b@eBPq@XgAR_ANe@FKHSDKNUBI",
                },
                start_location: {
                  lat: -1.3131121,
                  lng: 36.8549392,
                },
                travel_mode: "DRIVING",
                encoded_lat_lngs:
                  "|m_Gkf}_FAEAEBWDMDEDCJC?O@G@EDSZmAPq@b@eBPq@XgAR_ANe@FKHSDKNUBI",
                path: [
                  {
                    lat: -1.31311,
                    lng: 36.854940000000006,
                  },
                  {
                    lat: -1.3131000000000002,
                    lng: 36.85497,
                  },
                  {
                    lat: -1.31309,
                    lng: 36.855000000000004,
                  },
                  {
                    lat: -1.31311,
                    lng: 36.85512000000001,
                  },
                  {
                    lat: -1.3131400000000002,
                    lng: 36.85519,
                  },
                  {
                    lat: -1.3131700000000002,
                    lng: 36.85522,
                  },
                  {
                    lat: -1.3132000000000001,
                    lng: 36.85524,
                  },
                  {
                    lat: -1.31326,
                    lng: 36.85526,
                  },
                  {
                    lat: -1.31326,
                    lng: 36.855340000000005,
                  },
                  {
                    lat: -1.3132700000000002,
                    lng: 36.855380000000004,
                  },
                  {
                    lat: -1.31328,
                    lng: 36.855410000000006,
                  },
                  {
                    lat: -1.3133100000000002,
                    lng: 36.85551,
                  },
                  {
                    lat: -1.31345,
                    lng: 36.855900000000005,
                  },
                  {
                    lat: -1.3135400000000002,
                    lng: 36.85615,
                  },
                  {
                    lat: -1.31372,
                    lng: 36.856660000000005,
                  },
                  {
                    lat: -1.3138100000000001,
                    lng: 36.856910000000006,
                  },
                  {
                    lat: -1.31394,
                    lng: 36.85727,
                  },
                  {
                    lat: -1.31404,
                    lng: 36.85759,
                  },
                  {
                    lat: -1.3141200000000002,
                    lng: 36.857780000000005,
                  },
                  {
                    lat: -1.3141600000000002,
                    lng: 36.85784,
                  },
                  {
                    lat: -1.31421,
                    lng: 36.857940000000006,
                  },
                  {
                    lat: -1.31424,
                    lng: 36.858000000000004,
                  },
                  {
                    lat: -1.3143200000000002,
                    lng: 36.85811,
                  },
                  {
                    lat: -1.31434,
                    lng: 36.858160000000005,
                  },
                ],
                instructions:
                  'At the roundabout, take the <b>2nd</b> exit onto <b>Enterprise Rd</b><div style="font-size:0.9em">Destination will be on the left</div>',
                start_point: {
                  lat: -1.3131121,
                  lng: 36.8549392,
                },
                end_point: {
                  lat: -1.314339,
                  lng: 36.8581644,
                },
              },
            ],
            traffic_speed_entry: [],
            via_waypoint: [],
            via_waypoints: [],
          },
        ],
        overview_polyline:
          "v~`Gk{y_FcAhBwC}AYKk@C]l@s@tA_B|Ci@hAiEzIa@|@aB|Cw@pAg@n@_BnB_BxAuBxAoBfAmEhBeGxBgHhCyNfFwHhCiBn@u@^c@\\AJELURMDQ@OAMESWE]FYYcAs@uBuBmFyBsFo@sAgAaCOSCAIAMOAI?MDKs@mBiE}KqDgJeAuBQUC?ICQGKMGOAWFWRUZG^FLHf@O`KyDtIoD|@a@?CBEBCHEH?tA_@t@YTONQx@wAxA}B|E{Hn@oAF]?EJWLEZYh@y@xBoDnLqRv@{AF[t@mD@SAOCCEG?KJQHCTYh@gBdAmE^}AnAeF`AqErAqFCKHe@JIJC?OBMvAyFnA_Ff@aABI",
        summary: "Mombasa Road/A104 and Enterprise Rd",
        warnings: [],
        waypoint_order: [],
        overview_path: [
          {
            lat: -1.32092,
            lng: 36.83782,
          },
          {
            lat: -1.32058,
            lng: 36.83729,
          },
          {
            lat: -1.3198200000000002,
            lng: 36.83776,
          },
          {
            lat: -1.31969,
            lng: 36.83782,
          },
          {
            lat: -1.3194700000000001,
            lng: 36.83784,
          },
          {
            lat: -1.31932,
            lng: 36.837610000000005,
          },
          {
            lat: -1.3190600000000001,
            lng: 36.837180000000004,
          },
          {
            lat: -1.31858,
            lng: 36.83639,
          },
          {
            lat: -1.31837,
            lng: 36.836020000000005,
          },
          {
            lat: -1.31736,
            lng: 36.83428,
          },
          {
            lat: -1.31719,
            lng: 36.83397,
          },
          {
            lat: -1.3167000000000002,
            lng: 36.833180000000006,
          },
          {
            lat: -1.3164200000000001,
            lng: 36.832770000000004,
          },
          {
            lat: -1.3162200000000002,
            lng: 36.832530000000006,
          },
          {
            lat: -1.3157400000000001,
            lng: 36.831970000000005,
          },
          {
            lat: -1.31526,
            lng: 36.831520000000005,
          },
          {
            lat: -1.31467,
            lng: 36.831070000000004,
          },
          {
            lat: -1.3141100000000001,
            lng: 36.83071,
          },
          {
            lat: -1.31308,
            lng: 36.830180000000006,
          },
          {
            lat: -1.31177,
            lng: 36.829570000000004,
          },
          {
            lat: -1.3102900000000002,
            lng: 36.828880000000005,
          },
          {
            lat: -1.30776,
            lng: 36.82772000000001,
          },
          {
            lat: -1.3062,
            lng: 36.82703,
          },
          {
            lat: -1.30567,
            lng: 36.82679,
          },
          {
            lat: -1.3054000000000001,
            lng: 36.82663,
          },
          {
            lat: -1.30522,
            lng: 36.826480000000004,
          },
          {
            lat: -1.3052100000000002,
            lng: 36.826420000000006,
          },
          {
            lat: -1.30518,
            lng: 36.826350000000005,
          },
          {
            lat: -1.3050700000000002,
            lng: 36.82625,
          },
          {
            lat: -1.3050000000000002,
            lng: 36.826220000000006,
          },
          {
            lat: -1.30491,
            lng: 36.82621,
          },
          {
            lat: -1.3048300000000002,
            lng: 36.826220000000006,
          },
          {
            lat: -1.3047600000000001,
            lng: 36.82625,
          },
          {
            lat: -1.3046600000000002,
            lng: 36.826370000000004,
          },
          {
            lat: -1.3046300000000002,
            lng: 36.82652,
          },
          {
            lat: -1.30467,
            lng: 36.82665,
          },
          {
            lat: -1.30454,
            lng: 36.82699,
          },
          {
            lat: -1.30428,
            lng: 36.827580000000005,
          },
          {
            lat: -1.30369,
            lng: 36.828770000000006,
          },
          {
            lat: -1.30308,
            lng: 36.82999,
          },
          {
            lat: -1.30284,
            lng: 36.83041,
          },
          {
            lat: -1.30248,
            lng: 36.83106,
          },
          {
            lat: -1.3024,
            lng: 36.831160000000004,
          },
          {
            lat: -1.30238,
            lng: 36.83117,
          },
          {
            lat: -1.3023300000000002,
            lng: 36.83118,
          },
          {
            lat: -1.3022600000000002,
            lng: 36.83126,
          },
          {
            lat: -1.3022500000000001,
            lng: 36.83131,
          },
          {
            lat: -1.3022500000000001,
            lng: 36.83138,
          },
          {
            lat: -1.30228,
            lng: 36.83144,
          },
          {
            lat: -1.3020200000000002,
            lng: 36.831990000000005,
          },
          {
            lat: -1.30101,
            lng: 36.83406,
          },
          {
            lat: -1.3001200000000002,
            lng: 36.835860000000004,
          },
          {
            lat: -1.29977,
            lng: 36.836450000000006,
          },
          {
            lat: -1.2996800000000002,
            lng: 36.836560000000006,
          },
          {
            lat: -1.29966,
            lng: 36.836560000000006,
          },
          {
            lat: -1.2996100000000002,
            lng: 36.836580000000005,
          },
          {
            lat: -1.29952,
            lng: 36.83662,
          },
          {
            lat: -1.29946,
            lng: 36.836690000000004,
          },
          {
            lat: -1.29942,
            lng: 36.83677,
          },
          {
            lat: -1.2994100000000002,
            lng: 36.836890000000004,
          },
          {
            lat: -1.2994500000000002,
            lng: 36.83701000000001,
          },
          {
            lat: -1.2995500000000002,
            lng: 36.837120000000006,
          },
          {
            lat: -1.29969,
            lng: 36.837160000000004,
          },
          {
            lat: -1.2998500000000002,
            lng: 36.837120000000006,
          },
          {
            lat: -1.2999200000000002,
            lng: 36.837070000000004,
          },
          {
            lat: -1.3001200000000002,
            lng: 36.83715,
          },
          {
            lat: -1.3020500000000002,
            lng: 36.838080000000005,
          },
          {
            lat: -1.30376,
            lng: 36.83896,
          },
          {
            lat: -1.30407,
            lng: 36.839130000000004,
          },
          {
            lat: -1.30407,
            lng: 36.839150000000004,
          },
          {
            lat: -1.3040900000000002,
            lng: 36.839180000000006,
          },
          {
            lat: -1.30411,
            lng: 36.839200000000005,
          },
          {
            lat: -1.3041600000000002,
            lng: 36.83923,
          },
          {
            lat: -1.30421,
            lng: 36.83923,
          },
          {
            lat: -1.30464,
            lng: 36.83939,
          },
          {
            lat: -1.30491,
            lng: 36.83952,
          },
          {
            lat: -1.30502,
            lng: 36.839600000000004,
          },
          {
            lat: -1.3051000000000001,
            lng: 36.839690000000004,
          },
          {
            lat: -1.30539,
            lng: 36.84013,
          },
          {
            lat: -1.3058400000000001,
            lng: 36.84076,
          },
          {
            lat: -1.30695,
            lng: 36.84234,
          },
          {
            lat: -1.30719,
            lng: 36.842740000000006,
          },
          {
            lat: -1.3072300000000001,
            lng: 36.842890000000004,
          },
          {
            lat: -1.3072300000000001,
            lng: 36.84292000000001,
          },
          {
            lat: -1.30729,
            lng: 36.84304,
          },
          {
            lat: -1.30736,
            lng: 36.843070000000004,
          },
          {
            lat: -1.3075,
            lng: 36.8432,
          },
          {
            lat: -1.3077100000000002,
            lng: 36.84349,
          },
          {
            lat: -1.3083200000000001,
            lng: 36.844370000000005,
          },
          {
            lat: -1.31048,
            lng: 36.847500000000004,
          },
          {
            lat: -1.3107600000000001,
            lng: 36.84796,
          },
          {
            lat: -1.3108000000000002,
            lng: 36.8481,
          },
          {
            lat: -1.3110700000000002,
            lng: 36.84897,
          },
          {
            lat: -1.31108,
            lng: 36.849070000000005,
          },
          {
            lat: -1.3110700000000002,
            lng: 36.84915,
          },
          {
            lat: -1.31105,
            lng: 36.84917,
          },
          {
            lat: -1.31102,
            lng: 36.84921000000001,
          },
          {
            lat: -1.31102,
            lng: 36.849270000000004,
          },
          {
            lat: -1.31108,
            lng: 36.849360000000004,
          },
          {
            lat: -1.3111300000000001,
            lng: 36.849380000000004,
          },
          {
            lat: -1.3112400000000002,
            lng: 36.84951,
          },
          {
            lat: -1.31145,
            lng: 36.850030000000004,
          },
          {
            lat: -1.3118,
            lng: 36.851060000000004,
          },
          {
            lat: -1.31196,
            lng: 36.851530000000004,
          },
          {
            lat: -1.3123600000000002,
            lng: 36.85268000000001,
          },
          {
            lat: -1.3126900000000001,
            lng: 36.853730000000006,
          },
          {
            lat: -1.31311,
            lng: 36.854940000000006,
          },
          {
            lat: -1.31309,
            lng: 36.855000000000004,
          },
          {
            lat: -1.3131400000000002,
            lng: 36.85519,
          },
          {
            lat: -1.3132000000000001,
            lng: 36.85524,
          },
          {
            lat: -1.31326,
            lng: 36.85526,
          },
          {
            lat: -1.31326,
            lng: 36.855340000000005,
          },
          {
            lat: -1.31328,
            lng: 36.855410000000006,
          },
          {
            lat: -1.31372,
            lng: 36.856660000000005,
          },
          {
            lat: -1.3141200000000002,
            lng: 36.857780000000005,
          },
          {
            lat: -1.3143200000000002,
            lng: 36.85811,
          },
          {
            lat: -1.31434,
            lng: 36.858160000000005,
          },
        ],
      },
    ],
    status: "OK",
    request: {
      origin: {
        location: {
          lat: -1.321067,
          lng: 36.837724,
        },
      },
      destination: {
        location: {
          lat: -1.314098,
          lng: 36.858274,
        },
      },
      travelMode: "DRIVING",
    },
  },

  {
    geocoded_waypoints: [
      {
        geocoder_status: "OK",
        place_id: "ChIJBYZ3_RMRLxgRDZq1iKlNfvE",
        types: ["establishment", "point_of_interest"],
      },
      {
        geocoder_status: "OK",
        place_id: "ChIJk0qxgoQRLxgRJMpXStqNmSM",
        types: ["establishment", "point_of_interest"],
      },
    ],
    routes: [
      {
        bounds: {
          south: -1.31434,
          west: 36.83744,
          north: -1.2991100000000002,
          east: 36.858160000000005,
        },
        copyrights: "Map data ©2024",
        legs: [
          {
            distance: {
              text: "3.3 km",
              value: 3293,
            },
            duration: {
              text: "7 mins",
              value: 417,
            },
            end_address:
              "PJP Park, Enterprise Rd, Industrial Area, Box 61770 - 00200, Nairobi, Kenya",
            end_location: {
              lat: -1.314339,
              lng: 36.8581644,
            },
            start_address: "24 Addis Ababa Rd, Nairobi, Kenya",
            start_location: {
              lat: -1.2991054,
              lng: 36.8406533,
            },
            steps: [
              {
                distance: {
                  text: "0.4 km",
                  value: 400,
                },
                duration: {
                  text: "2 mins",
                  value: 103,
                },
                end_location: {
                  lat: -1.3007176,
                  lng: 36.8374415,
                },
                polyline: {
                  points: "lv|Famz_Fv@lBdBnEFP\\v@Ld@NVZr@bAfC",
                },
                start_location: {
                  lat: -1.2991054,
                  lng: 36.8406533,
                },
                travel_mode: "DRIVING",
                encoded_lat_lngs: "lv|Famz_Fv@lBdBnEFP\\v@Ld@NVZr@bAfC",
                path: [
                  {
                    lat: -1.2991100000000002,
                    lng: 36.840650000000004,
                  },
                  {
                    lat: -1.29939,
                    lng: 36.8401,
                  },
                  {
                    lat: -1.2999,
                    lng: 36.83906,
                  },
                  {
                    lat: -1.29994,
                    lng: 36.83897,
                  },
                  {
                    lat: -1.3000900000000002,
                    lng: 36.83869,
                  },
                  {
                    lat: -1.3001600000000002,
                    lng: 36.8385,
                  },
                  {
                    lat: -1.30024,
                    lng: 36.83838,
                  },
                  {
                    lat: -1.30038,
                    lng: 36.83812,
                  },
                  {
                    lat: -1.30072,
                    lng: 36.83744,
                  },
                ],
                instructions:
                  'Head <b>southwest</b> on <b>Addis Ababa Rd</b> toward <b>Athi River Rd</b><div style="font-size:0.9em">Pass by Rhodium Steel Limited (on the left in 300m)</div>',
                maneuver: "",
                start_point: {
                  lat: -1.2991054,
                  lng: 36.8406533,
                },
                end_point: {
                  lat: -1.3007176,
                  lng: 36.8374415,
                },
              },
              {
                distance: {
                  text: "1.9 km",
                  value: 1925,
                },
                duration: {
                  text: "3 mins",
                  value: 209,
                },
                end_location: {
                  lat: -1.3114489,
                  lng: 36.8500307,
                },
                maneuver: "turn-left",
                polyline: {
                  points:
                    "n`}F_yy_FdBq@bDmA^OnAi@dBu@~B_AZM`@S?A?A@A?A@A@A?A@?@A@?@A@?@A@?@?@?@?@?@?@@pAa@TINEJGBALIFEDEHKT]b@y@n@cAh@y@f@u@|@_BnAmBf@w@R_@NWDMDIFW?A?A?A?A?A?A?A?C@C@A?C@A@ABC@ABA@?@A@?@?@?@?NQFG@CDGLQR[T]R]T[@CPYR]@ANYHOrBeDl@aA|BwD`A{AXi@FG`@s@n@kAFOBIBQn@sCDY@K?G?MA??AA??AA??AA??AAA?AAA?A?A?A?A?A?A?A@A?A?A@A?A@A@A@A@??A@?@??A@?@?@?@AFGJOZcALc@",
                },
                start_location: {
                  lat: -1.3007176,
                  lng: 36.8374415,
                },
                travel_mode: "DRIVING",
                encoded_lat_lngs:
                  "n`}F_yy_FdBq@bDmA^OnAi@dBu@~B_AZM`@S?A?A@A?A@A@A?A@?@A@?@A@?@A@?@?@?@?@?@?@@pAa@TINEJGBALIFEDEHKT]b@y@n@cAh@y@f@u@|@_BnAmBf@w@R_@NWDMDIFW?A?A?A?A?A?A?A?C@C@A?C@A@ABC@ABA@?@A@?@?@?@?NQFG@CDGLQR[T]R]T[@CPYR]@ANYHOrBeDl@aA|BwD`A{AXi@FG`@s@n@kAFOBIBQn@sCDY@K?G?MA??AA??AA??AA??AAA?AAA?A?A?A?A?A?A?A@A?A?A@A?A@A@A@A@??A@?@??A@?@?@?@AFGJOZcALc@",
                path: [
                  {
                    lat: -1.30072,
                    lng: 36.83744,
                  },
                  {
                    lat: -1.30123,
                    lng: 36.83769,
                  },
                  {
                    lat: -1.3020500000000002,
                    lng: 36.838080000000005,
                  },
                  {
                    lat: -1.30221,
                    lng: 36.83816,
                  },
                  {
                    lat: -1.30261,
                    lng: 36.838370000000005,
                  },
                  {
                    lat: -1.30312,
                    lng: 36.838640000000005,
                  },
                  {
                    lat: -1.30376,
                    lng: 36.83896,
                  },
                  {
                    lat: -1.3039,
                    lng: 36.83903,
                  },
                  {
                    lat: -1.30407,
                    lng: 36.839130000000004,
                  },
                  {
                    lat: -1.30407,
                    lng: 36.83914,
                  },
                  {
                    lat: -1.30407,
                    lng: 36.839150000000004,
                  },
                  {
                    lat: -1.3040800000000001,
                    lng: 36.83916,
                  },
                  {
                    lat: -1.3040800000000001,
                    lng: 36.83917,
                  },
                  {
                    lat: -1.3040900000000002,
                    lng: 36.839180000000006,
                  },
                  {
                    lat: -1.3041,
                    lng: 36.83919,
                  },
                  {
                    lat: -1.3041,
                    lng: 36.839200000000005,
                  },
                  {
                    lat: -1.30411,
                    lng: 36.839200000000005,
                  },
                  {
                    lat: -1.3041200000000002,
                    lng: 36.83921,
                  },
                  {
                    lat: -1.30413,
                    lng: 36.83921,
                  },
                  {
                    lat: -1.30414,
                    lng: 36.839220000000005,
                  },
                  {
                    lat: -1.3041500000000001,
                    lng: 36.839220000000005,
                  },
                  {
                    lat: -1.3041600000000002,
                    lng: 36.83923,
                  },
                  {
                    lat: -1.30417,
                    lng: 36.83923,
                  },
                  {
                    lat: -1.3041800000000001,
                    lng: 36.83923,
                  },
                  {
                    lat: -1.3041900000000002,
                    lng: 36.83923,
                  },
                  {
                    lat: -1.3042,
                    lng: 36.83923,
                  },
                  {
                    lat: -1.30421,
                    lng: 36.83923,
                  },
                  {
                    lat: -1.3042200000000002,
                    lng: 36.83923,
                  },
                  {
                    lat: -1.30423,
                    lng: 36.839220000000005,
                  },
                  {
                    lat: -1.30464,
                    lng: 36.83939,
                  },
                  {
                    lat: -1.30475,
                    lng: 36.83944,
                  },
                  {
                    lat: -1.3048300000000002,
                    lng: 36.839470000000006,
                  },
                  {
                    lat: -1.30489,
                    lng: 36.839510000000004,
                  },
                  {
                    lat: -1.30491,
                    lng: 36.83952,
                  },
                  {
                    lat: -1.30498,
                    lng: 36.83957,
                  },
                  {
                    lat: -1.30502,
                    lng: 36.839600000000004,
                  },
                  {
                    lat: -1.30505,
                    lng: 36.83963,
                  },
                  {
                    lat: -1.3051000000000001,
                    lng: 36.839690000000004,
                  },
                  {
                    lat: -1.3052100000000002,
                    lng: 36.83984,
                  },
                  {
                    lat: -1.30539,
                    lng: 36.84013,
                  },
                  {
                    lat: -1.30563,
                    lng: 36.84047,
                  },
                  {
                    lat: -1.3058400000000001,
                    lng: 36.84076,
                  },
                  {
                    lat: -1.30604,
                    lng: 36.84103,
                  },
                  {
                    lat: -1.3063500000000001,
                    lng: 36.84151,
                  },
                  {
                    lat: -1.30675,
                    lng: 36.842060000000004,
                  },
                  {
                    lat: -1.30695,
                    lng: 36.84234,
                  },
                  {
                    lat: -1.30705,
                    lng: 36.8425,
                  },
                  {
                    lat: -1.3071300000000001,
                    lng: 36.842620000000004,
                  },
                  {
                    lat: -1.30716,
                    lng: 36.842690000000005,
                  },
                  {
                    lat: -1.30719,
                    lng: 36.842740000000006,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.84286,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.842870000000005,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.84288,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.842890000000004,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.8429,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.84291,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.84292000000001,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.84293,
                  },
                  {
                    lat: -1.3072300000000001,
                    lng: 36.84295,
                  },
                  {
                    lat: -1.3072400000000002,
                    lng: 36.84297,
                  },
                  {
                    lat: -1.30725,
                    lng: 36.842980000000004,
                  },
                  {
                    lat: -1.30725,
                    lng: 36.843,
                  },
                  {
                    lat: -1.30726,
                    lng: 36.84301,
                  },
                  {
                    lat: -1.3072700000000002,
                    lng: 36.84302,
                  },
                  {
                    lat: -1.30729,
                    lng: 36.84304,
                  },
                  {
                    lat: -1.3073000000000001,
                    lng: 36.843050000000005,
                  },
                  {
                    lat: -1.30732,
                    lng: 36.84306,
                  },
                  {
                    lat: -1.30733,
                    lng: 36.84306,
                  },
                  {
                    lat: -1.3073400000000002,
                    lng: 36.843070000000004,
                  },
                  {
                    lat: -1.30735,
                    lng: 36.843070000000004,
                  },
                  {
                    lat: -1.30736,
                    lng: 36.843070000000004,
                  },
                  {
                    lat: -1.3073700000000001,
                    lng: 36.843070000000004,
                  },
                  {
                    lat: -1.3073800000000002,
                    lng: 36.843070000000004,
                  },
                  {
                    lat: -1.30746,
                    lng: 36.843160000000005,
                  },
                  {
                    lat: -1.3075,
                    lng: 36.8432,
                  },
                  {
                    lat: -1.3075100000000002,
                    lng: 36.84322,
                  },
                  {
                    lat: -1.3075400000000001,
                    lng: 36.84326,
                  },
                  {
                    lat: -1.3076100000000002,
                    lng: 36.84335,
                  },
                  {
                    lat: -1.3077100000000002,
                    lng: 36.84349,
                  },
                  {
                    lat: -1.3078200000000002,
                    lng: 36.84364,
                  },
                  {
                    lat: -1.3079200000000002,
                    lng: 36.843790000000006,
                  },
                  {
                    lat: -1.30803,
                    lng: 36.84393,
                  },
                  {
                    lat: -1.30804,
                    lng: 36.84395,
                  },
                  {
                    lat: -1.30813,
                    lng: 36.844080000000005,
                  },
                  {
                    lat: -1.30823,
                    lng: 36.84423,
                  },
                  {
                    lat: -1.30824,
                    lng: 36.844240000000006,
                  },
                  {
                    lat: -1.3083200000000001,
                    lng: 36.844370000000005,
                  },
                  {
                    lat: -1.30837,
                    lng: 36.84445,
                  },
                  {
                    lat: -1.30895,
                    lng: 36.84528,
                  },
                  {
                    lat: -1.30918,
                    lng: 36.84561,
                  },
                  {
                    lat: -1.3098100000000001,
                    lng: 36.84653,
                  },
                  {
                    lat: -1.31014,
                    lng: 36.846990000000005,
                  },
                  {
                    lat: -1.31027,
                    lng: 36.8472,
                  },
                  {
                    lat: -1.31031,
                    lng: 36.847240000000006,
                  },
                  {
                    lat: -1.31048,
                    lng: 36.847500000000004,
                  },
                  {
                    lat: -1.31072,
                    lng: 36.84788,
                  },
                  {
                    lat: -1.3107600000000001,
                    lng: 36.84796,
                  },
                  {
                    lat: -1.31078,
                    lng: 36.84801,
                  },
                  {
                    lat: -1.3108000000000002,
                    lng: 36.8481,
                  },
                  {
                    lat: -1.3110400000000002,
                    lng: 36.84884,
                  },
                  {
                    lat: -1.3110700000000002,
                    lng: 36.84897,
                  },
                  {
                    lat: -1.31108,
                    lng: 36.849030000000006,
                  },
                  {
                    lat: -1.31108,
                    lng: 36.849070000000005,
                  },
                  {
                    lat: -1.31108,
                    lng: 36.849140000000006,
                  },
                  {
                    lat: -1.3110700000000002,
                    lng: 36.849140000000006,
                  },
                  {
                    lat: -1.3110700000000002,
                    lng: 36.84915,
                  },
                  {
                    lat: -1.3110600000000001,
                    lng: 36.84915,
                  },
                  {
                    lat: -1.3110600000000001,
                    lng: 36.849160000000005,
                  },
                  {
                    lat: -1.31105,
                    lng: 36.849160000000005,
                  },
                  {
                    lat: -1.31105,
                    lng: 36.84917,
                  },
                  {
                    lat: -1.3110400000000002,
                    lng: 36.84917,
                  },
                  {
                    lat: -1.3110400000000002,
                    lng: 36.849180000000004,
                  },
                  {
                    lat: -1.3110300000000001,
                    lng: 36.84919,
                  },
                  {
                    lat: -1.3110300000000001,
                    lng: 36.8492,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.84921000000001,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.84922,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.849230000000006,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.84924,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.849250000000005,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.84926,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.849270000000004,
                  },
                  {
                    lat: -1.31102,
                    lng: 36.84928,
                  },
                  {
                    lat: -1.3110300000000001,
                    lng: 36.84929,
                  },
                  {
                    lat: -1.3110300000000001,
                    lng: 36.8493,
                  },
                  {
                    lat: -1.3110300000000001,
                    lng: 36.84931,
                  },
                  {
                    lat: -1.3110400000000002,
                    lng: 36.849320000000006,
                  },
                  {
                    lat: -1.3110400000000002,
                    lng: 36.84933,
                  },
                  {
                    lat: -1.31105,
                    lng: 36.849340000000005,
                  },
                  {
                    lat: -1.3110600000000001,
                    lng: 36.84935,
                  },
                  {
                    lat: -1.3110700000000002,
                    lng: 36.849360000000004,
                  },
                  {
                    lat: -1.31108,
                    lng: 36.849360000000004,
                  },
                  {
                    lat: -1.31108,
                    lng: 36.84937,
                  },
                  {
                    lat: -1.31109,
                    lng: 36.84937,
                  },
                  {
                    lat: -1.3111000000000002,
                    lng: 36.84937,
                  },
                  {
                    lat: -1.3111000000000002,
                    lng: 36.849380000000004,
                  },
                  {
                    lat: -1.31111,
                    lng: 36.849380000000004,
                  },
                  {
                    lat: -1.31112,
                    lng: 36.849380000000004,
                  },
                  {
                    lat: -1.3111300000000001,
                    lng: 36.849380000000004,
                  },
                  {
                    lat: -1.3111400000000002,
                    lng: 36.84939,
                  },
                  {
                    lat: -1.31118,
                    lng: 36.849430000000005,
                  },
                  {
                    lat: -1.3112400000000002,
                    lng: 36.84951,
                  },
                  {
                    lat: -1.3113800000000002,
                    lng: 36.84985,
                  },
                  {
                    lat: -1.31145,
                    lng: 36.850030000000004,
                  },
                ],
                instructions:
                  'Turn <b>left</b> at Family bank atm-enterprise Rd onto <b>Enterprise Rd</b><div style="font-size:0.9em">Go through 3 roundabouts</div><div style="font-size:0.9em">Pass by M-Pesa Ropem Telcom Ltd (on the left)</div>',
                start_point: {
                  lat: -1.3007176,
                  lng: 36.8374415,
                },
                end_point: {
                  lat: -1.3114489,
                  lng: 36.8500307,
                },
              },
              {
                distance: {
                  text: "0.6 km",
                  value: 576,
                },
                duration: {
                  text: "1 min",
                  value: 61,
                },
                end_location: {
                  lat: -1.3131121,
                  lng: 36.8549392,
                },
                polyline: {
                  points: "pc_Gug|_F^_Bd@mBR{@BIFWPu@|@oDNi@p@gDhAwEHY",
                },
                start_location: {
                  lat: -1.3114489,
                  lng: 36.8500307,
                },
                travel_mode: "DRIVING",
                encoded_lat_lngs: "pc_Gug|_F^_Bd@mBR{@BIFWPu@|@oDNi@p@gDhAwEHY",
                path: [
                  {
                    lat: -1.31145,
                    lng: 36.850030000000004,
                  },
                  {
                    lat: -1.3116100000000002,
                    lng: 36.85051,
                  },
                  {
                    lat: -1.3118,
                    lng: 36.851060000000004,
                  },
                  {
                    lat: -1.3119,
                    lng: 36.85136,
                  },
                  {
                    lat: -1.3119200000000002,
                    lng: 36.85141,
                  },
                  {
                    lat: -1.31196,
                    lng: 36.851530000000004,
                  },
                  {
                    lat: -1.3120500000000002,
                    lng: 36.851800000000004,
                  },
                  {
                    lat: -1.3123600000000002,
                    lng: 36.85268000000001,
                  },
                  {
                    lat: -1.31244,
                    lng: 36.85289,
                  },
                  {
                    lat: -1.3126900000000001,
                    lng: 36.853730000000006,
                  },
                  {
                    lat: -1.3130600000000001,
                    lng: 36.85481,
                  },
                  {
                    lat: -1.31311,
                    lng: 36.854940000000006,
                  },
                ],
                instructions:
                  'Continue onto <b>Enterprise Road</b><div style="font-size:0.9em">Pass by Joy Enterprises Shop (on the right)</div>',
                maneuver: "",
                start_point: {
                  lat: -1.3114489,
                  lng: 36.8500307,
                },
                end_point: {
                  lat: -1.3131121,
                  lng: 36.8549392,
                },
              },
              {
                distance: {
                  text: "0.4 km",
                  value: 392,
                },
                duration: {
                  text: "1 min",
                  value: 44,
                },
                end_location: {
                  lat: -1.314339,
                  lng: 36.8581644,
                },
                maneuver: "roundabout-left",
                polyline: {
                  points:
                    "|m_Gkf}_FAEAEBWDMDEDCJC?O@G@EDSZmAPq@b@eBPq@XgAR_ANe@FKHSDKNUBI",
                },
                start_location: {
                  lat: -1.3131121,
                  lng: 36.8549392,
                },
                travel_mode: "DRIVING",
                encoded_lat_lngs:
                  "|m_Gkf}_FAEAEBWDMDEDCJC?O@G@EDSZmAPq@b@eBPq@XgAR_ANe@FKHSDKNUBI",
                path: [
                  {
                    lat: -1.31311,
                    lng: 36.854940000000006,
                  },
                  {
                    lat: -1.3131000000000002,
                    lng: 36.85497,
                  },
                  {
                    lat: -1.31309,
                    lng: 36.855000000000004,
                  },
                  {
                    lat: -1.31311,
                    lng: 36.85512000000001,
                  },
                  {
                    lat: -1.3131400000000002,
                    lng: 36.85519,
                  },
                  {
                    lat: -1.3131700000000002,
                    lng: 36.85522,
                  },
                  {
                    lat: -1.3132000000000001,
                    lng: 36.85524,
                  },
                  {
                    lat: -1.31326,
                    lng: 36.85526,
                  },
                  {
                    lat: -1.31326,
                    lng: 36.855340000000005,
                  },
                  {
                    lat: -1.3132700000000002,
                    lng: 36.855380000000004,
                  },
                  {
                    lat: -1.31328,
                    lng: 36.855410000000006,
                  },
                  {
                    lat: -1.3133100000000002,
                    lng: 36.85551,
                  },
                  {
                    lat: -1.31345,
                    lng: 36.855900000000005,
                  },
                  {
                    lat: -1.3135400000000002,
                    lng: 36.85615,
                  },
                  {
                    lat: -1.31372,
                    lng: 36.856660000000005,
                  },
                  {
                    lat: -1.3138100000000001,
                    lng: 36.856910000000006,
                  },
                  {
                    lat: -1.31394,
                    lng: 36.85727,
                  },
                  {
                    lat: -1.31404,
                    lng: 36.85759,
                  },
                  {
                    lat: -1.3141200000000002,
                    lng: 36.857780000000005,
                  },
                  {
                    lat: -1.3141600000000002,
                    lng: 36.85784,
                  },
                  {
                    lat: -1.31421,
                    lng: 36.857940000000006,
                  },
                  {
                    lat: -1.31424,
                    lng: 36.858000000000004,
                  },
                  {
                    lat: -1.3143200000000002,
                    lng: 36.85811,
                  },
                  {
                    lat: -1.31434,
                    lng: 36.858160000000005,
                  },
                ],
                instructions:
                  'At the roundabout, take the <b>2nd</b> exit onto <b>Enterprise Rd</b><div style="font-size:0.9em">Pass by Tetra Pak (on the left)</div><div style="font-size:0.9em">Destination will be on the left</div>',
                start_point: {
                  lat: -1.3131121,
                  lng: 36.8549392,
                },
                end_point: {
                  lat: -1.314339,
                  lng: 36.8581644,
                },
              },
            ],
            traffic_speed_entry: [],
            via_waypoint: [],
            via_waypoints: [],
          },
        ],
        overview_polyline:
          "lv|Famz_FbEfK\\|@~AzDxJyDbHwCDKHEHAB?rA_@d@Od@YNQx@wA~DsGvBeDb@w@Rq@?GDSPKD?^e@hCaEvKqQh@{@v@{A|@iE@a@CCEGAKHSHCBARWh@gBxAiGzAgG`AqErAqFCKHe@JIJC?OBM`@aB`BqGb@eBP_@Xk@",
        summary: "Enterprise Rd",
        warnings: [],
        waypoint_order: [],
        overview_path: [
          {
            lat: -1.2991100000000002,
            lng: 36.840650000000004,
          },
          {
            lat: -1.3000900000000002,
            lng: 36.83869,
          },
          {
            lat: -1.30024,
            lng: 36.83838,
          },
          {
            lat: -1.30072,
            lng: 36.83744,
          },
          {
            lat: -1.30261,
            lng: 36.838370000000005,
          },
          {
            lat: -1.30407,
            lng: 36.839130000000004,
          },
          {
            lat: -1.3041,
            lng: 36.83919,
          },
          {
            lat: -1.3041500000000001,
            lng: 36.839220000000005,
          },
          {
            lat: -1.3042,
            lng: 36.83923,
          },
          {
            lat: -1.3042200000000002,
            lng: 36.83923,
          },
          {
            lat: -1.30464,
            lng: 36.83939,
          },
          {
            lat: -1.3048300000000002,
            lng: 36.839470000000006,
          },
          {
            lat: -1.30502,
            lng: 36.839600000000004,
          },
          {
            lat: -1.3051000000000001,
            lng: 36.839690000000004,
          },
          {
            lat: -1.30539,
            lng: 36.84013,
          },
          {
            lat: -1.3063500000000001,
            lng: 36.84151,
          },
          {
            lat: -1.30695,
            lng: 36.84234,
          },
          {
            lat: -1.3071300000000001,
            lng: 36.842620000000004,
          },
          {
            lat: -1.3072300000000001,
            lng: 36.842870000000005,
          },
          {
            lat: -1.3072300000000001,
            lng: 36.84291,
          },
          {
            lat: -1.30726,
            lng: 36.84301,
          },
          {
            lat: -1.30735,
            lng: 36.843070000000004,
          },
          {
            lat: -1.3073800000000002,
            lng: 36.843070000000004,
          },
          {
            lat: -1.3075400000000001,
            lng: 36.84326,
          },
          {
            lat: -1.30823,
            lng: 36.84423,
          },
          {
            lat: -1.31027,
            lng: 36.8472,
          },
          {
            lat: -1.31048,
            lng: 36.847500000000004,
          },
          {
            lat: -1.3107600000000001,
            lng: 36.84796,
          },
          {
            lat: -1.3110700000000002,
            lng: 36.84897,
          },
          {
            lat: -1.31108,
            lng: 36.849140000000006,
          },
          {
            lat: -1.3110600000000001,
            lng: 36.849160000000005,
          },
          {
            lat: -1.3110300000000001,
            lng: 36.8492,
          },
          {
            lat: -1.31102,
            lng: 36.84926,
          },
          {
            lat: -1.3110700000000002,
            lng: 36.849360000000004,
          },
          {
            lat: -1.31112,
            lng: 36.849380000000004,
          },
          {
            lat: -1.3111400000000002,
            lng: 36.84939,
          },
          {
            lat: -1.3112400000000002,
            lng: 36.84951,
          },
          {
            lat: -1.31145,
            lng: 36.850030000000004,
          },
          {
            lat: -1.3119,
            lng: 36.85136,
          },
          {
            lat: -1.3123600000000002,
            lng: 36.85268000000001,
          },
          {
            lat: -1.3126900000000001,
            lng: 36.853730000000006,
          },
          {
            lat: -1.31311,
            lng: 36.854940000000006,
          },
          {
            lat: -1.31309,
            lng: 36.855000000000004,
          },
          {
            lat: -1.3131400000000002,
            lng: 36.85519,
          },
          {
            lat: -1.3132000000000001,
            lng: 36.85524,
          },
          {
            lat: -1.31326,
            lng: 36.85526,
          },
          {
            lat: -1.31326,
            lng: 36.855340000000005,
          },
          {
            lat: -1.31328,
            lng: 36.855410000000006,
          },
          {
            lat: -1.31345,
            lng: 36.855900000000005,
          },
          {
            lat: -1.31394,
            lng: 36.85727,
          },
          {
            lat: -1.3141200000000002,
            lng: 36.857780000000005,
          },
          {
            lat: -1.31421,
            lng: 36.857940000000006,
          },
          {
            lat: -1.31434,
            lng: 36.858160000000005,
          },
        ],
      },
    ],
    status: "OK",
    request: {
      origin: {
        location: {
          lat: -1.299237,
          lng: 36.84072,
        },
      },
      destination: {
        location: {
          lat: -1.314098,
          lng: 36.858274,
        },
      },
      travelMode: "DRIVING",
    },
  },
];

export default directions;
